<style>
    /* =========================================
       ESTILOS BASE
       ========================================= */
    .Contadores > .v-sheet.v-card{
        font-size: 0.75rem;
        font-weight: 400;
        letter-spacing: 0.0178571em;
        padding: 24px;
        text-transform: none;
        line-height: 1.25rem;
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        width:200px;
        height:120px;
    }
    
    /* =========================================
       ESTILOS TARJETAS KPI (Dashboard Gerencial)
       ========================================= */
    .kpi-card-modern {
        border-radius: 12px !important;
        padding: 24px;
        background-color: #ffffff;
        border: 1px solid #e2e8f0;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .kpi-card-modern:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
    }
    .kpi-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }
    .kpi-title {
        font-size: 0.75rem;
        font-weight: 800;
        color: #64748b;
        letter-spacing: 0.5px;
    }
    .kpi-body {
        margin-bottom: 5px;
    }
    .kpi-value {
        font-size: 2.2rem;
        font-weight: 900;
        color: #0f172a;
        line-height: 1.1;
        letter-spacing: -0.5px;
    }
    .kpi-footer {
        display: flex;
        align-items: center;
        margin-top: 15px;
    }
    .kpi-trend {
        display: flex;
        align-items: center;
        padding: 4px 10px;
        border-radius: 20px;
        font-weight: 800;
        font-size: 0.80rem;
        margin-right: 12px;
    }
    .trend-up {
        background-color: #d1fae5;
        color: #059669;
    }
    .trend-up .v-icon { color: #059669 !important; font-size: 16px !important; margin-right: 2px;}
    .trend-down {
        background-color: #ffe4e6;
        color: #e11d48;
    }
    .trend-down .v-icon { color: #e11d48 !important; font-size: 16px !important; margin-right: 2px;}
    .kpi-compare-text {
        color: #94a3b8;
        font-size: 0.85rem;
        font-weight: 600;
    }

    /* =========================================
       REDISEÑO DE TABLAS MODERNAS (Dentro de Tabs)
       ========================================= */
    .modern-table-container {
        overflow-x: auto; 
        width: 100%;
        border-radius: 8px;
        border: 1px solid #e2e8f0;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
        background: #ffffff;
    }
    .modern-table {
        width: 100%;
        border-collapse: collapse;
        min-width: 600px;
    }
    /* Centrado global de celdas para que se vea parejo */
    .modern-table th, .modern-table td {
        text-align: center !important;
        vertical-align: middle !important;
    }
    /* La primera columna siempre alineada a la izquierda */
    .modern-table th:first-child, .modern-table td:first-child {
        text-align: left !important;
        padding-left: 20px !important;
    }
    
    .modern-table th {
        background: #f8fafc !important;
        color: #115bb7 !important;
        font-weight: 800 !important;
        font-size: 0.75rem !important;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 14px 12px !important;
        border-bottom: 2px solid #e2e8f0 !important;
        white-space: nowrap;
    }
    .modern-table td {
        padding: 12px !important;
        font-size: 0.85rem !important;
        color: #334155 !important;
        border-bottom: 1px solid #e2e8f0 !important;
    }
    .modern-table tbody tr {
        transition: background-color 0.2s ease;
    }
    .modern-table tbody tr:hover {
        background-color: #f0f7ff !important;
    }

    /* Indicador de tendencia miniatura dentro de las tablas */
    .trend-indicator {
        display: inline-flex;
        align-items: center;
        padding: 3px 8px;
        border-radius: 20px;
        font-size: 0.70rem;
        font-weight: 800;
        line-height: 1;
        white-space: nowrap;
    }

    /* Títulos h3 dentro de las tarjetas */
    .transition-fast-in-fast-out h3 {
        font-size: 1.1rem;
        color: #0f172a;
        font-weight: 800;
        margin-bottom: 5px;
        border-left: 4px solid #115bb7;
        padding-left: 10px;
    }
    .transition-fast-in-fast-out {
        box-shadow: none !important;
        border: 1px solid #e2e8f0 !important;
        border-radius: 12px !important;
        flex: 1 1 100%; 
        min-width: 300px;
        background: #ffffff;
    }

    /* Ajuste para los v-data-table nativos superiores */
    .v-data-table.elevation-1, .v-data-table.elevation-3 {
        border-radius: 12px !important;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
        overflow: hidden;
    }
</style>

<template>
    <v-layout>
        <v-flex>
            <!-- Encabezado Principal -->
            <div class="d-flex align-center mb-4" style="padding: 20px 20px 0;">
                <v-icon color="#115bb7" size="36" class="mr-3">dashboard</v-icon>
                <h1 style="color: #0f172a; font-weight: 800; font-size: 1.8rem; margin: 0;">Reporte de Actividades</h1>         
            </div>

            <!-- SECCIÓN DE TABLAS BASE (Cotizaciones, Solicitudes) -->
            <div class="px-5">
                <v-card style="margin-top: 10px; border-radius: 12px; box-shadow: none; background: transparent;">
                    
                    <v-data-table
                            v-model="DetallesCotizaciones"
                            v-if="DetallesCotizaciones"
                            :headers="headerC"
                            :items="cotizaciones"
                            class="elevation-1 mb-6"
                            :search="search"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'skip_previous',
                                lastIcon: 'skip_next',
                                prevIcon: 'keyboard_arrow_left',
                                nextIcon: 'keyboard_arrow_right'
                            }"
                        >
                            <template v-slot:top>
                                <v-toolbar flat color="white" style="border-bottom: 1px solid #e2e8f0;">
                                    <v-toolbar-title style="font-weight: 700; color: #115bb7;">Cotizaciones</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details outlined dense></v-text-field>
                                    <v-spacer></v-spacer>       
                                    <v-btn @click="exportExcel(2)" color="#115bb7" dark elevation="0" style="border-radius: 8px;">
                                        <v-icon left>file_download</v-icon> Descargar
                                    </v-btn>                              
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.opciones`]="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">                    
                                        <v-icon v-bind="attrs" v-on="on" small @click="ViewCot(item)" style="padding: 4px; border: 1px solid #e2e8f0; border-radius: 6px;" color="#115bb7">
                                            add
                                        </v-icon>
                                    </template>
                                    <span>Ver detalles</span>
                                </v-tooltip>
                            </template> 
                    </v-data-table>

                    <v-data-table
                        v-if="DetallesBs"
                        :headers="headers"
                        :items="bs"
                        :hide-default-footer="nfooter"
                        :items-per-page="pagina"
                        class="elevation-1 mb-6"
                    >
                        <template v-slot:[`item.activo`]="{ item }">
                            <v-icon v-if="item.activo === true" small class="mr-2" style="color: #059669; font-weight: 600;">done</v-icon>  
                            <v-icon v-else small class="mr-2" style="color: #e11d48; font-weight: 600;">clear</v-icon> 
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat color="white" style="border-bottom: 1px solid #e2e8f0;">
                                <v-toolbar-title style="font-weight: 700; color: #115bb7;">Reporte BS</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>                        
                                <v-btn @click="exportExcel(1)" color="#115bb7" dark elevation="0" style="border-radius: 8px;">
                                    <v-icon left>file_download</v-icon> Descargar
                                </v-btn>
                            </v-toolbar>
                        </template> 
                    </v-data-table>

                    <v-data-table
                        v-if="DetallesSol"
                        :headers="HeaderSolicitud"
                        :items="SolicitudT"        
                        :search="searchs"
                        class="elevation-1 mb-6"
                        loading-text="Cargando información..."
                        :footer-props="{ showFirstLastPage: true }"
                        >
                        <template v-slot:[`item.status`]="{ item }">
                            <table style="width: 100%;min-width: 110px;" v-if="item.activo == true">
                                <tr>
                                    <td style="border: 0; padding: 0;">
                                        <v-icon v-if="item.recollecion == true" style="font-size: 20px;" :color="getColor(item.recollecionstatus)">local_shipping</v-icon>
                                        <v-icon v-if="item.recollecion == true" style="font-size: 12px;font-weight: 600;" :color="getColor(item.recollecionstatus)">arrow_forward</v-icon>
                                        <v-icon v-if="item.principal == true && item.basis =='AEREO'" style="font-size: 20px;" :color="getColor(item.principalstatus)">flight_takeoff</v-icon>
                                        <v-icon v-if="item.principal == true && (item.basis =='FCL' || item.basis =='LCL')" style="font-size: 20px;" :color="getColor(item.principalstatus)">directions_boat</v-icon>
                                        <v-icon v-if="item.principal == true && (item.basis =='FTL' || item.basis =='LTL')" style="font-size: 20px;" :color="getColor(item.principalstatus)">local_shipping</v-icon>
                                        <v-icon v-if="item.entrega == true" style="font-size: 12px;font-weight: 600;" :color="getColor(item.entregastatus)">arrow_forward</v-icon>
                                        <v-icon v-if="item.entrega == true" style="font-size: 20px;" :color="getColor(item.entregastatus)">local_shipping</v-icon>
                                        <v-icon v-if="item.viewextra == true" style="font-size: 12px;font-weight: 600;margin-top: -15px;" :color="getColor(item.statusadicional)">add</v-icon>
                                    </td>
                                </tr>
                            </table>
                            <span v-else> <v-icon color="#e11d48">cancel</v-icon></span>
                        </template>
                        <template v-slot:[`item.ncotizacion`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.ncotizacion}}</span>
                            <span v-else style="font-size: 0.675rem;">{{item.ncotizacion}}</span>
                        </template>
                        <template v-slot:[`item.ncustumer`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.ncustumer}}</span>
                            <span v-else style="font-size: 0.675rem;">{{item.ncustumer}}</span>
                        </template>
                        <template v-slot:[`item.tipoOp`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.tipoOp}}</span>
                            <span v-else style="font-size: 0.675rem;">{{item.tipoOp}}</span>
                        </template>
                        <template v-slot:[`item.basis`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.basis}}</span>
                            <span v-else style="font-size: 0.675rem;">{{item.basis}}</span>
                        </template>
                        <template v-slot:[`item.npuertoreceipt`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertoreceipt === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertoreceipt}}</span>
                            </span>
                            <span v-else style="font-size: 0.675rem;">
                                <span v-if="item.npuertoreceipt === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertoreceipt}}</span>
                            </span>
                        </template>
                        <template v-slot:[`item.npuertoloading`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertoloading === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertoloading}}</span>
                            </span>
                            <span v-else style="font-size: 0.675rem;">
                                <span v-if="item.npuertoloading === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertoloading}}</span>
                            </span>
                        </template>
                        <template v-slot:[`item.npuertodischarge`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertodischarge === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertodischarge}}</span>
                            </span>
                            <span v-else style="font-size: 0.675rem;">
                                <span v-if="item.npuertodischarge === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertodischarge}}</span>
                            </span>
                        </template>
                        <template v-slot:[`item.npuertodelivery`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertodelivery === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertodelivery}}</span>
                            </span>
                            <span v-else style="font-size: 0.675rem;">
                                <span v-if="item.npuertodelivery === 'SELECT..'">-</span>
                                <span v-else>{{item.npuertodelivery}}</span>
                            </span>
                        </template>
                        <template v-slot:[`item.nfechacreate`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.nfechacreate}}</span>
                            <span v-else style="font-size: 0.675rem;">{{item.nfechacreate}}</span>
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat color="white" style="border-bottom: 1px solid #e2e8f0;">
                                <v-toolbar-title style="font-weight: 700; color: #115bb7;">Solicitud de tarifa</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details outlined dense></v-text-field>                                
                                <v-spacer></v-spacer> 
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-card>
            </div>

            <!-- DIALOGO DE INFORMACIÓN DE COTIZACIÓN -->
            <div >
                <v-dialog width="800" style="background: white;" v-model="InfoCot">
                    <v-card-text style="background: white; padding: 24px;">
                        <div style="margin-bottom: 20px;">
                            <header style="width: 100%">
                                <table style="width: 100%;">
                                    <tr>
                                        <td>
                                            <img style="width: 220px;" src="../assets/logo.png" alt="">
                                        </td>
                                        <td style="text-align: end;">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="text-align: end;font-size: 14px;font-weight: 600;">CDMX, a {{fechaHoy}}</td>
                                    </tr>
                                </table>
                            </header>
                            <section>
                                <table style="width: 100%;">
                                    <tr>
                                        <td style="font-size: 14px;font-weight: 600;">Folio de Cotización: <span style="color:black;">{{ncotizacion}}</span></td>
                                    </tr>
                                    <tr>
                                        <td style="font-size: 14px;font-weight: 600;">Cliente: {{ncustumre}}</td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Modalidad: </span>
                                            <v-text-field style="margin-left: 8px;" v-model="modalidadtext2" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Movimiento:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="Movimientotext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Producto:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="productotext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Origen:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="origentext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Destino:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="destinotext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Servicio:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="serviciotext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Via:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="viatext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Transbordo:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="transbordo" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">T.T.:</span>
                                            <v-text-field style="margin-left: 8px;" v-model="tttext" solo dense></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-checkbox v-model="MostrarTotal" value="1" label="Mostrar Total" style="width:150px;" hide-details dense></v-checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <v-simple-table style="margin-bottom: 12px;">
                                                <thead>
                                                    <tr>
                                                        <th>CONCEPTO</th>
                                                        <th>COSTO POR:</th>
                                                        <th>CANTIDAD</th>
                                                        <th>COSTO UNITARIO</th>
                                                        <th>MONEDA</th>
                                                        <th>SUB TOTAL</th>
                                                        <th>IVA</th>
                                                        <th>TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="det in costos">
                                                        <tr v-if="det.activo === true" :key="det.idtarifascot">
                                                            <td style="text-align: center;">{{det.concepto}}</td>
                                                            <td style="text-align: center;">{{det.costopor}}</td>
                                                            <td style="text-align: center;">{{det.cantidad}}</td>
                                                            <td style="text-align: center;">{{det.ncostounitario}}</td>
                                                            <td style="text-align: center;">{{det.moneda}}</td>
                                                            <td style="text-align: center;">{{det.nsubtotal}}</td>
                                                            <td style="text-align: center;">{{det.nniva}}</td>
                                                            <td style="text-align: center;">{{det.ntotal}}</td>
                                                        </tr>
                                                    </template>
                                                    <tr v-if="activousd == true && MostrarTotal == 1">
                                                        <td></td><td></td><td></td><td></td><td></td>
                                                        <td style="text-align: center;">Total USD</td>
                                                        <td style="text-align: center;">{{nsubtotalusd}}</td>
                                                        <td style="text-align: center;">{{nivausd}}</td>
                                                        <td style="text-align: center;">{{ntotalusd}}</td>
                                                    </tr>
                                                    <tr v-if="activomxn == true && MostrarTotal == 1">
                                                        <td></td><td></td><td></td><td></td><td></td>
                                                        <td style="text-align: center;">Total MXN</td>
                                                        <td style="text-align: center;">{{nsubtotalmxn}}</td>
                                                        <td style="text-align: center;">{{nivamxn}}</td>
                                                        <td style="text-align: center;">{{ntotalmxn}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="display: flex;align-items: center;">
                                            <span>Vigencia:</span>  
                                            <v-menu v-model="menu2" :close-on-content-click="false" max-width="290" dense>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field :value="computedDateFormatrecei" clearable readonly v-bind="attrs" v-on="on" @click:clear="dateval = null" dense :rules="[v => !!v || 'Date pick up is required']"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dateval" @change="menu2 = false" :min="nowDate" :max="vigenciatarifa"></v-date-picker>
                                            </v-menu> 
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <v-simple-table style="margin-bottom: 12px;">
                                                <thead>
                                                    <tr>
                                                        <th>Remarks</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in remarkstextc" :key="det.idobs">
                                                        <template v-if="det.activo == true">
                                                            <td>{{det.text}}</td>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </td>
                                    </tr>
                                </table>
                            </section>
                        </div>
                    </v-card-text>
                </v-dialog>
            </div>

            <!-- DIALOGO CARGANDO -->
            <div >
                <v-dialog v-model="dialodload" hide-overlay persistent width="300">
                    <v-card color="#115bb7" dark>
                        <v-card-text class="text-center pt-4 pb-4">
                            Procesando datos, por favor espere...
                            <v-progress-linear indeterminate color="white" class="mb-0 mt-3"></v-progress-linear>                    
                        </v-card-text>
                    </v-card>
                </v-dialog>  
            </div>

            <!-- SECCIÓN DASHBOARD MULTIANUAL -->
            <div class="px-5">
                <!-- PANEL DE CONFIGURACIÓN -->
                <v-card class="mb-5 elevation-1" style="border-radius: 12px; border-left: 5px solid #115bb7;">
                    <v-card-title style="font-size: 1.1rem; font-weight: 700; color: #334155; padding-bottom: 0;">
                        <v-icon color="#115bb7" class="mr-2">stacked_bar_chart</v-icon>
                        Configuración de Reporte Multianual
                    </v-card-title>
                    
                    <v-card-text class="pt-4">
                        <v-row align="center">
                            <v-col cols="12" md="5" class="py-0">
                                <span style="font-weight: 700; color: #475569; font-size: 0.85rem;">AÑOS A COMPARAR</span>
                                <v-select v-model="aniosSeleccionados" :items="listaAnios" multiple chips deletable-chips small-chips outlined dense hide-details class="mt-1" placeholder="Selecciona 1 o más años"></v-select>
                            </v-col>

                            <v-col cols="12" md="4" class="py-0">
                                <span style="font-weight: 700; color: #475569; font-size: 0.85rem;">MES DE ANÁLISIS</span>
                                <v-select v-model="mesSeleccionado" :items="listaMeses" outlined dense hide-details clearable class="mt-1" placeholder="Todo el Año"></v-select>
                            </v-col>

                            <v-col cols="12" md="3" class="d-flex justify-end mt-4 mt-md-0">
                                <v-btn color="#115bb7" dark large elevation="0" style="font-weight: 700; border-radius: 8px; width: 100%;" @click="EjecutarComparativa()">
                                    <v-icon left>query_stats</v-icon> ANALIZAR DATOS
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>                

                <!-- TARJETAS KPI -->
                <v-row v-if="verreporte" class="mx-0 mb-6 mt-2">
                    <!-- KPI 1: Ventas -->
                    <v-col cols="12" md="6" class="px-2">
                        <v-card class="kpi-card-modern">
                            <div class="kpi-header">
                                <span class="kpi-title">TOTAL VENTAS ({{ anioMasReciente }}) <span v-if="mesSeleccionado">| Mes: {{mesSeleccionado}}</span></span>
                                <v-icon color="#115bb7" size="28">payments</v-icon>
                            </div>
                            <div class="kpi-body">
                                <span class="kpi-value">$ {{ addCommas(parseFloat(kpiVentasActual).toFixed(2)) }}</span>
                            </div>
                            <div class="kpi-footer" v-if="anioAnterior">
                                <span class="kpi-trend" :class="kpiVentasActual >= kpiVentasAnterior ? 'trend-up' : 'trend-down'">
                                    <v-icon small>{{ kpiVentasActual >= kpiVentasAnterior ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                                    {{ calcularPorcentaje(kpiVentasActual, kpiVentasAnterior) }}%
                                </span>
                                <span class="kpi-compare-text">vs {{ anioAnterior }} ($ {{ addCommas(parseFloat(kpiVentasAnterior).toFixed(2)) }})</span>
                            </div>
                            
                            <!-- HISTÓRICO EXTRA -->
                            <div v-if="aniosSeleccionados.length > 2" class="mt-4 pt-3" style="border-top: 1px dashed #cbd5e1;">
                                <span style="font-size: 0.70rem; color: #64748b; font-weight: 700; text-transform: uppercase;">Otros años en análisis:</span>
                                <div style="display: flex; gap: 15px; margin-top: 4px; flex-wrap: wrap;">
                                    <span v-for="anio in aniosSeleccionados.filter(a => a !== anioMasReciente && a !== anioAnterior)" :key="'v-'+anio" 
                                        style="font-size: 0.85rem; font-weight: 700; color: #334155;">
                                        <v-icon small color="#94a3b8" class="mr-1">history</v-icon>
                                        {{ anio }}: $ {{ kpiHistoricoVentas[anio] ? addCommas(parseFloat(kpiHistoricoVentas[anio]).toFixed(2)) : '0.00' }}
                                    </span>
                                </div>
                            </div>
                        </v-card>
                    </v-col>

                    <!-- KPI 2: Total de BS -->
                    <v-col cols="12" md="6" class="px-2">
                        <v-card class="kpi-card-modern">
                            <div class="kpi-header">
                                <span class="kpi-title">TOTAL BS GENERADAS ({{ anioMasReciente }})</span>
                                <v-icon color="#115bb7" size="28">assignment_turned_in</v-icon>
                            </div>
                            <div class="kpi-body">
                                <span class="kpi-value">{{ kpiBsActual }} <span style="font-size: 1rem; color: #64748b; font-weight: 600;">Operaciones</span></span>
                            </div>
                            <div class="kpi-footer" v-if="anioAnterior">
                                <span class="kpi-trend" :class="kpiBsActual >= kpiBsAnterior ? 'trend-up' : 'trend-down'">
                                    <v-icon small>{{ kpiBsActual >= kpiBsAnterior ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                                    {{ calcularPorcentaje(kpiBsActual, kpiBsAnterior) }}%
                                </span>
                                <span class="kpi-compare-text">vs {{ anioAnterior }} ({{ kpiBsAnterior }} Operaciones)</span>
                            </div>
                            
                            <!-- HISTÓRICO EXTRA -->
                            <div v-if="aniosSeleccionados.length > 2" class="mt-4 pt-3" style="border-top: 1px dashed #cbd5e1;">
                                <span style="font-size: 0.70rem; color: #64748b; font-weight: 700; text-transform: uppercase;">Otros años en análisis:</span>
                                <div style="display: flex; gap: 15px; margin-top: 4px; flex-wrap: wrap;">
                                    <span v-for="anio in aniosSeleccionados.filter(a => a !== anioMasReciente && a !== anioAnterior)" :key="'b-'+anio" 
                                        style="font-size: 0.85rem; font-weight: 700; color: #334155;">
                                        <v-icon small color="#94a3b8" class="mr-1">history</v-icon>
                                        {{ anio }}: {{ kpiHistoricoBs[anio] || 0 }} Operaciones
                                    </span>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>  

                <!-- ==============================================
                     NAVEGACIÓN POR PESTAÑAS (TABS) CON TABLAS MODERNIZADAS
                     ============================================== -->
                <v-card v-if="verreporte" elevation="1" style="border-radius: 12px; overflow: hidden; margin-bottom: 30px; border: 1px solid #e2e8f0;">
                    <v-tabs v-model="tabActual" background-color="#f8fafc" color="#115bb7" grow show-arrows>
                        <v-tab style="font-weight: 700; letter-spacing: 0.5px;"><v-icon left>leaderboard</v-icon> Finanzas y Ejecutivos</v-tab>
                        <v-tab style="font-weight: 700; letter-spacing: 0.5px;"><v-icon left>local_shipping</v-icon> Rendimiento por Servicio</v-tab>
                        <v-tab style="font-weight: 700; letter-spacing: 0.5px;"><v-icon left>support_agent</v-icon> Actividad Comercial</v-tab>
                        <v-tab style="font-weight: 700; letter-spacing: 0.5px;"><v-icon left>business</v-icon> Cartera de Clientes</v-tab>
                        <v-tab style="font-weight: 700; letter-spacing: 0.5px;"><v-icon left>calendar_month</v-icon> Estacionalidad Clientes</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tabActual" style="background-color: transparent; padding: 20px;">
                        
                        <!-- PESTAÑA 1: FINANZAS Y EJECUTIVOS -->
                        <v-tab-item>
                            <div style="display:flex; flex-wrap: wrap; gap: 20px; justify-content: space-between;">  
                                
                                <!-- 1. Ventas por mes -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px; width: 100%;">
                                    <h3>Desglose de Ventas por Mes</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Mes</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>                            
                                                <tr v-for="det in meses" :key="det.value">                                        
                                                    <td>
                                                        <div class="d-flex align-center">
                                                            <v-btn v-if="det.value != 13" icon small color="#115bb7" class="mr-3" @click="AbrirDetalleMes(det)" elevation="0" style="background-color: #e0f2fe; border: 1px solid #bae6fd;">
                                                                <v-icon small color="#0284c7">visibility</v-icon>
                                                            </v-btn>
                                                            <span :style="det.value == 13 ? 'font-weight: 800;' : 'font-weight: 600; color: #334155;'">{{det.text}}</span>
                                                        </div>                                            
                                                    </td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in reportecompleto" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span :style="(det.value == 13 || an.text == 'Total') ? 'font-weight: 800; font-size: 0.95rem;' : 'font-weight: 600;'">
                                                                    $ {{addCommas(parseFloat(comp.text).toFixed(2))}}
                                                                </span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(reportecompleto, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'text')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 14px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>

                                <!-- 2. Ventas por Ejecutivo -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>Ventas por Ejecutivo</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Ejecutivo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>                            
                                                <tr v-for="det in usuariosReporte" :key="det.num">
                                                    <td>
                                                        <span :style="det.value == -1 ? 'font-weight: 800;' : 'font-weight: 600; color: #334155;'">{{det.text}}</span>
                                                    </td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in profitusuarios" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span :style="(det.value == -1 || an.text == 'Total') ? 'font-weight: 800;' : 'font-weight: 600;'">
                                                                    $ {{ addCommas(parseFloat(comp.profitt).toFixed(2))}}
                                                                </span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(profitusuarios, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'profitt')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>                                                
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>  

                                <!-- 3. BS por Ejecutivo -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>BS's por Ejecutivo</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Ejecutivo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>                            
                                                <tr v-for="det in usuariosReporte" :key="det.num">
                                                    <td>
                                                        <span :style="det.value == -1 ? 'font-weight: 800;' : 'font-weight: 600; color: #334155;'">{{det.text}}</span>
                                                    </td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in profitusuarios" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span :style="(det.value == -1 || an.text == 'Total') ? 'font-weight: 800;' : 'font-weight: 600;'">
                                                                    {{addCommas(parseFloat(comp.bs))}}
                                                                </span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(profitusuarios, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'bs')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>

                                <!-- 4. Profit Promedio por BS -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>Profit Promedio por BS</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Ejecutivo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>                            
                                                <tr v-for="det in usuariosReporte" :key="det.num">
                                                    <td>
                                                        <span :style="det.value == -1 ? 'font-weight: 800;' : 'font-weight: 600; color: #334155;'">{{det.text}}</span>
                                                    </td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in profitusuarios" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span :style="(det.value == -1 || an.text == 'Total') ? 'font-weight: 800;' : 'font-weight: 600;'">
                                                                    $ {{addCommas(parseFloat(comp.profitt / comp.bs).toFixed(2))}}
                                                                </span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(profitusuarios, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'profitt', null, null, 'bs')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>
                            </div>
                        </v-tab-item>

                        <!-- PESTAÑA 2: RENDIMIENTO POR SERVICIO -->
                        <v-tab-item>
                            <div style="display:flex; flex-wrap: wrap; gap: 20px; justify-content: space-between;">  
                                
                                <!-- 5. Monto Profit -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>Monto Profit</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in TipoOperacionC" :key="det.num">
                                                    <td><strong style="color: #334155;">{{det.text}}</strong></td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in profitbasis" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value && det.idtipoOp == comp.idtipoOp" class="d-flex flex-column align-center justify-center">
                                                                <span style="font-weight: 600;">$ {{addCommas(parseFloat(comp.profitbasis).toFixed(2))}}</span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(profitbasis, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'profitbasis', 'idtipoOp', det.idtipoOp)]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>

                                <!-- 6. No. BS -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>No. BS (Operaciones)</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in TipoOperacionC" :key="det.num">
                                                    <td><strong style="color: #334155;">{{det.text}}</strong></td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in profitbasis" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value && det.idtipoOp == comp.idtipoOp" class="d-flex flex-column align-center justify-center">
                                                                <span style="font-weight: 600;">{{comp.bs}}</span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(profitbasis, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'bs', 'idtipoOp', det.idtipoOp)]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>

                                <!-- 7. Profit Promedio por BS (Servicio) -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>Profit promedio por BS</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in TipoOperacionC" :key="det.num">
                                                    <td><strong style="color: #334155;">{{det.text}}</strong></td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in profitbasis" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value && det.idtipoOp == comp.idtipoOp" class="d-flex flex-column align-center justify-center">
                                                                <span style="font-weight: 600;">$ {{addCommas(parseFloat(comp.profitbasis/comp.bs).toFixed(2))}}</span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(profitbasis, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'profitbasis', 'idtipoOp', det.idtipoOp, 'bs')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> 
                                </v-card>
                            </div>
                        </v-tab-item>

                        <!-- PESTAÑA 3: ACTIVIDAD COMERCIAL -->
                        <v-tab-item>
                            <div style="display:flex; flex-wrap: wrap; gap: 20px; justify-content: space-between;">  
                                
                                <!-- 8. Llamadas en el año -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>Llamadas en el año</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Ejecutivo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>                            
                                                <tr v-for="det in usuariosReporteActividad" :key="det.num">
                                                    <td><span style="font-weight: 600; color: #334155;">{{det.text}}</span></td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in actividadesusuario" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span :style="(det.value == -1 || an.text == 'Total') ? 'font-weight: 800;' : 'font-weight: 600;'">
                                                                    {{comp.llamadas}}
                                                                </span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(actividadesusuario, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'llamadas')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>

                                <!-- 9. Cotizaciones en el año -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>Cotizaciones en el año</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Ejecutivo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>                            
                                                <tr v-for="det in usuariosReporteActividadc" :key="det.num">
                                                    <td><span style="font-weight: 600; color: #334155;">{{det.text}}</span></td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in actividadesusuarioc" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span :style="(det.value == -1 || an.text == 'Total') ? 'font-weight: 800;' : 'font-weight: 600;'">
                                                                    {{comp.cotizaciones}}
                                                                </span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(actividadesusuarioc, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'cotizaciones')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>

                                <!-- 10. Cotizaciones por Tipo -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px;">
                                    <h3>No. Cotizaciones por Tipo</h3>
                                    <div class="modern-table-container">
                                        <table class="modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in TipoOperacionAC" :key="det.num">
                                                    <td><strong style="color: #334155;">{{det.text}}</strong></td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in CantidadOperacionBAsisC" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value && det.idtipoOp == comp.idtipoOp" class="d-flex flex-column align-center justify-center">
                                                                <span style="font-weight: 600;">{{comp.cuenta}}</span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(CantidadOperacionBAsisC, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'cuenta', 'idtipoOp', det.idtipoOp)]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>
                            </div>
                        </v-tab-item>

                        <!-- PESTAÑA 4: CARTERA DE CLIENTES -->
                        <v-tab-item>
                            <div style="display:flex; flex-wrap: wrap; gap: 20px; justify-content: space-between;">  
                                
                                <!-- 11. Clientes -->
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px; width: 100%;">
                                    <h3>Reporte General de Clientes</h3>
                                    <div class="modern-table-container" style="max-height: 500px; overflow-y: auto;">
                                        <table class="modern-table">
                                            <thead style="position: sticky; top: 0; z-index: 2; box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);">
                                                <tr>
                                                    <th>Principales Clientes</th>
                                                    <th v-for="deta in años" :key="deta.num">{{ deta.text }}</th>
                                                    <th>Vendedor</th>
                                                    <th>EXP-IMP</th>
                                                    <th>TIPO</th>
                                                    <th>POL</th>
                                                    <th>POD</th>
                                                    <th>COMMODITY</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="det in ListadoClientes" :key="det.num">
                                                    <td style="font-weight: 700;">{{det.text}}</td>
                                                    <td v-for="(an, index) in años" :key="an.num">
                                                        <div v-for="comp in ReporteporCliente" :key="comp.num">
                                                            <div v-if="an.text == comp.año && det.value == comp.value" class="d-flex flex-column align-center justify-center">
                                                                <span style="font-weight: 600; font-size: 0.90rem;">$ {{addCommas(parseFloat(comp.profitaño).toFixed(2))}}</span>
                                                                <div v-if="index > 0 && an.text !== 'Total'">
                                                                    <div v-for="trend in [getTrendData(ReporteporCliente, 'value', det.value, an.text, años[index > 0 ? index - 1 : 0].text, 'profitaño')]" :key="an.text + 't'">
                                                                        <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                            <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                            {{ trend.pct }}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>                                          
                                                    <td style="text-align: center !important;">{{det.ejecutivoall}}</td>
                                                    <td style="text-align: center !important;">{{det.ntipoOp}}</td>
                                                    <td style="text-align: center !important;">{{det.nbasis}}</td>
                                                    <td style="text-align: center !important;">{{det.npol}}</td>
                                                    <td style="text-align: center !important;">{{det.npod}}</td>
                                                    <td style="text-align: center !important;">{{det.commodity}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>
                            </div>
                        </v-tab-item>

                        <!-- PESTAÑA 5: ESTACIONALIDAD DE CLIENTES -->
                        <v-tab-item>
                            <div style="display:flex; flex-wrap: wrap; gap: 20px; justify-content: space-between;">  
                                <v-card class="transition-fast-in-fast-out v-card--reveal" style="padding: 24px; width: 100%;">
                                    <div class="d-flex justify-space-between align-center mb-3">
                                        <div>
                                            <h3>Rentabilidad Mensual por Cliente (Estacionalidad Anual)</h3>
                                            <p style="color: #64748b; font-size: 0.85rem; margin-bottom: 0;">
                                                <v-icon small color="#059669">info</v-icon> El rendimiento se agrupa por cliente, mostrando una fila por cada año operado. La celda verde indica el <strong>mejor mes</strong> de cada año.
                                            </p>
                                        </div>
                                        <v-btn @click="exportExcelEstacionalidad" color="#059669" dark elevation="0" style="border-radius: 8px;">
                                            <v-icon left>file_download</v-icon> Exportar Excel
                                        </v-btn>
                                    </div>

                                    <div class="modern-table-container" style="max-height: 600px; overflow-y: auto;">
                                        <table class="modern-table">
                                            <thead style="position: sticky; top: 0; z-index: 2; box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);">
                                                <tr>
                                                    <th>Cliente</th>
                                                    <th>Año</th>
                                                    <th>Ene</th><th>Feb</th><th>Mar</th><th>Abr</th><th>May</th><th>Jun</th>
                                                    <th>Jul</th><th>Ago</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Dic</th>
                                                    <th style="background-color: #e0f2fe !important; color: #0284c7 !important;">TOTAL AÑO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="cliente in rentabilidadClienteMes">
                                                    <tr v-for="(itemYear, idx) in cliente.yearsArray" :key="cliente.nombre + itemYear.year">
                                                        <td v-if="idx === 0" :rowspan="cliente.yearsArray.length" style="font-weight: 700; color: #334155; text-align: left !important; padding-left: 20px !important; border-right: 1px solid #e2e8f0; vertical-align: middle !important; background-color: #f8fafc;">
                                                            {{ cliente.nombre }}
                                                        </td>
                                                        <td style="font-weight: 800; color: #115bb7; border-left: 1px solid #e2e8f0;">{{ itemYear.year }}</td>
                                                        <td :style="getBestMonth(itemYear) === 1 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[1] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 2 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[2] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 3 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[3] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 4 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[4] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 5 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[5] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 6 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[6] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 7 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[7] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 8 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[8] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 9 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[9] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 10 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[10] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 11 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[11] || 0).toFixed(2)) }}</td>
                                                        <td :style="getBestMonth(itemYear) === 12 ? 'background-color: #dcfce7 !important; color: #166534 !important; font-weight: 800;' : ''">$ {{ addCommas(parseFloat(itemYear[12] || 0).toFixed(2)) }}</td>
                                                        <td style="font-weight: 800; background-color: #f0f9ff !important; color: #0369a1 !important;">$ {{ addCommas(parseFloat(itemYear.total || 0).toFixed(2)) }}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-card>
                            </div>
                        </v-tab-item>

                    </v-tabs-items>
                </v-card>

                <!-- MODAL: DETALLE DE VENTAS POR MES Y EJECUTIVO -->
                <v-dialog v-model="modalMesEjecutivo" max-width="800px" scrollable>
                    <v-card style="border-radius: 12px; overflow: hidden;">
                        <v-card-title style="font-weight: 800; color: #115bb7; background-color: #f8fafc; border-bottom: 1px solid #e2e8f0; padding: 20px;">
                            <v-icon color="#115bb7" size="28" class="mr-2">analytics</v-icon>
                            Ventas de {{ mesSeleccionadoModal.text }} por Ejecutivo
                            <v-spacer></v-spacer>
                            <v-btn icon @click="modalMesEjecutivo = false"><v-icon>close</v-icon></v-btn>
                        </v-card-title>
                        
                        <v-card-text style="padding: 20px; background-color: #ffffff;">
                            <div class="modern-table-container">
                                <table class="modern-table">
                                    <thead style="position: sticky; top: 0; z-index: 2;">
                                        <tr>
                                            <th>Ejecutivo</th>
                                            <th v-for="an in años" :key="an.num">{{ an.text }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in datosMesEjecutivo" :key="index">
                                            <td style="font-weight: 700; color: #334155; text-align: left !important; padding-left: 20px !important;">{{ item.nombre }}</td>
                                            <td v-for="(an, idx) in años" :key="an.num">
                                                <div class="d-flex flex-column align-center justify-center">
                                                    <span style="font-weight: 600;">$ {{ addCommas(parseFloat(item[an.text] || 0).toFixed(2)) }}</span>
                                                    <div v-if="idx > 0">
                                                        <div v-for="trend in [getModalTrend(item, an.text, años[idx > 0 ? idx - 1 : 0].text)]" :key="an.text + 't'">
                                                            <span v-if="trend" class="trend-indicator mt-1" :style="{ color: trend.color, backgroundColor: trend.bg }">
                                                                <v-icon small :color="trend.color" style="font-size: 12px; margin-right: 2px;">{{ trend.icon }}</v-icon>
                                                                {{ trend.pct }}%
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="datosMesEjecutivo.length === 0">
                                            <td :colspan="años.length + 1" style="text-align: center; color: #94a3b8; padding: 20px !important;">
                                                No hay datos de ventas registrados para este mes.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </div>
         </v-flex>
    </v-layout>
</template>
<script>
import axios from 'axios'
import * as XLSX from 'xlsx'

export default {    
    data(){
         const anioActual = new Date().getFullYear();

        return{
            tabActual: 0, 
            modalMesEjecutivo: false,
            mesSeleccionadoModal: {},
            datosMesEjecutivo: [],
            datosCrudosVentas: [],
            rentabilidadClienteMes: [], 
            detallepormes: false,
            aniosSeleccionados: [anioActual - 1, anioActual], 
            mesSeleccionado: null,          
            listaAnios: [], 
            listaMeses: [
                { text: 'Todo el Año', value: null },
                { text: 'Enero', value: 1 }, { text: 'Febrero', value: 2 },
                { text: 'Marzo', value: 3 }, { text: 'Abril', value: 4 },
                { text: 'Mayo', value: 5 }, { text: 'Junio', value: 6 },
                { text: 'Julio', value: 7 }, { text: 'Agosto', value: 8 },
                { text: 'Septiembre', value: 9 }, { text: 'Octubre', value: 10 },
                { text: 'Noviembre', value: 11 }, { text: 'Diciembre', value: 12 },
                { text: 'Total', value: 13 } 
            ],       
            kpiVentasActual: 0,
            kpiVentasAnterior: 0,
            kpiBsActual: 0,
            kpiBsAnterior: 0,
            kpiHistoricoVentas: {},
            kpiHistoricoBs: {},
            anioMasReciente: '',
            anioAnterior: '',    
            verreporte:false,
            cantidadaños:0,
            meses:[
                {text:'Enero',value:1}, {text:'Febrero',value:2}, {text:'Marzo',value:3},
                {text:'Abril',value:4}, {text:'Mayo',value:5}, {text:'Junio',value:6},
                {text:'Julio',value:7}, {text:'Agosto',value:8}, {text:'Septiembre',value:9},
                {text:'Octubre',value:10}, {text:'Noviembre',value:11}, {text:'Diciembre',value:12},
                {text:'Total',value:13},
            ],
            años:[],
            numeroan:[
                {text:'1',value:1}, {text:'2',value:2}, {text:'3',value:3},
            ],
            headerreportemes:[],
            pagina:-1,
            nfooter:false,
            fechaInicio: false,
            FechaFin:false,
            dateInicio: '',
            dateFin:'',
            ncolor:'',
            porsentajecumplido:0,
            value:75,
            a:88,
            b:76,
            c:45,
            d:76,
            ejecutivos:[],
            idejecutivo:0,
            COT:0,
            SLC:0,
            LLS:0,
            BS:0,
            BuySellLista:[],
            BSC:0,
            BuySellListaC:[],
            VentaTotal:0,
            headers: [
                {text:'Usuario',sortable: false,value: 'EJECUTIVO',align:'center'},
                {text:'BS', value: 'BS',align:'center' },
                {text:'OSCAR', value: 'OSCAR',align:'center' },
                {text:'CUSTOMER', value: 'CLIENTE' ,align:'center'},
                {text:'FCH_CREATE', value: 'FECHA_GENERADA' ,align:'center'},
                {text:'POL', value: 'POL' ,align:'center'},
                {text:'ETD', value: 'ETD' ,align:'center'},
                {text:'ETA', value: 'ETA' ,align:'center'},
                {text:'POD', value: 'POD' ,align:'center'},
                {text:'MODALITY', value: 'MODALITY' ,align:'center'},
                {text:'BASIS', value: 'BASIS' ,align:'center'},
                {text:'# CONTAINERS', value: 'CONTAINERS' ,align:'center'},
                {text:'TAMAÑO', value: 'TAMAÑO' ,align:'center'},
                {text:'TIPO', value: 'TIPO' ,align:'center'},
                {text:'VENTA', value: 'VENTA' ,align:'center'},
                {text:'COMPRA', value: 'COMPRA' ,align:'center'},
                {text:'PROFIT', value: 'PROFIT' ,align:'center'},
            ],
            headerC: [
                {text:'Opciones', value: 'opciones', sortable: false,align:'center' },
                {text:'Ncotizacion',sortable: false,value: 'ncotizacion',align:'center'},
                {text:'Customer',sortable: false,value: 'ncustumer',align:'center'},
                {text:'Origen', value: 'origen',align:'center' },
                {text:'Destino', value: 'destino' ,align:'center'},
                {text:'Modalidad', value: 'modalidad' ,align:'center'},
                {text:'Movimiento', value: 'movimiento' ,align:'center'},
                {text:'Fecha envio', value: 'fechsend' ,align:'center'},
            ],
            HeaderBuySellLista:[
                {text:'',value:'opciones',align:'center'},
                {text:'BS NUMBER',value:'nbuysell',align:'center'},
                {text:'CUSTOMER NAME',value:'tipoOp',align:'center'},
                {text:'OPERATION TYPE',value:'basis',align:'center'},
                {text:'BASIS',value:'modalidad',align:'center'},
                {text:'MODALITY',value:'receipt',align:'center'},
                {text:'PLACE OF RECEIPT',value:'loading',align:'center'},
                {text:'POL',value:'discharge',align:'center'},
                {text:'POD',value:'delivery',align:'center'},
                {text:'FINAL DESTINATION',value:'delivery',align:'center'},
            ],
            CotizacionesDatos:[],
            search:'',
            DetallesCotizaciones:false,
            DetallesBs:false,
            InfoCot:false,
            fechaHoy:'',
            chargeconcepto:'',
            remarkstextc:[],
            productotext:'',
            origentext:'',
            cuerpo:'',
            destinotext:'',
            serviciotext:'',
            viatext:'',
            tttext:'',
            Movimientotext:'',
            modalidadtext2:'',
            dateval:'',
            idcustumer:'',
            ncotizacion:'',
            ncustumre:'',
            folio:'',
            basis: [], 
            idcotizacion:'',
            transbordo:'',
            lclviewremarks: false,
            searcho:'',
            contactospresente:[],
            contactosprospecto:[],
            contactoscot:'',
            remk:'',
            menu2:'',
            nowDate: new Date().toISOString().slice(0,10),
            vigenciatarifa:null,
            preciocostopor:[],
            chargecostopor:'',
            activarc:false,
            chargecantidad:'',
            chargecostounitario:0,
            monedas:[],
            chargemoneda:'',
            chargeiva:0,
            MostrarTotal:false,
            costos:[],
            activousd:false,
            activomxn:false,
            bs:[],
            dialodload:false,
            TotalProfit:0,
            hbln:'',
            mbln:'',
            nusuario:'',
            nagente:'',
            tipoOp:'',
            nbuysell:'',
            nbasis:'',
            ncustumer:'',
            nmodalidad:'', 
            totalsell:0,
            totalbuy:0,
            totalselliva:0,
            totalbuyiva:0,
            totalprofitiva:0,
            totalbuybs:0,
            totalsellbs:0,
            tprofitbs:0,
            cotizaciones:[],
            fechaHoyN:'',
            DetallesSol:false,
            HeaderSolicitud:[
                {text:'TARIFF N°',value:'ncotizacion',align:'center', sortable: false},
                {text:'CUSTOMER NAME',value:'ncustumer',align:'center', sortable: false},
                {text:'OPERATION TYPE',value:'tipoOp',align:'center', sortable: false},
                {text:'BASIS',value:'basis',align:'center', sortable: false},
                {text:'PLACE OF RECEIPT',value:'npuertoreceipt',align:'center', sortable: false},
                {text:'POL',value:'npuertoloading',align:'center', sortable: false},
                {text:'POD',value:'npuertodischarge',align:'center', sortable: false},
                {text:'FINAL DESTINATION',value:'npuertodelivery',align:'center', sortable: false},
                {text:'APPLICATION DATE',value:'nfechacreate',align:'center', sortable: false},
                {text:'ANSWER DATE',value:'nfecharespuesta',align:'center', sortable: false},
                {text:'STATUS',value:'status',align:'center', sortable: false},
            ],
            SolicitudT:[],
            searchs:'',
            enero:0, febrero:0, marzo:0, abril:0, mayo:0, junio:0, julio:0,
            agosto:0, septiembre:0, octubre:0, noviembre:0, diciembre:0,
            reportecompleto:[],
            profitusuarios:[],
            usuariosReporte:[],
            profitbasis:[],
            TipoOperacion:[],
            TipoOperacionC:[],
            ListadoClientes:[],
            customer:[],
            ReporteporCliente:[],
            actividadesusuario:[],
            usuariosReporteActividad:[],
            usuariosReporteActividadc:[],
            actividadesusuarioc:[],
            TipoOperacionAC:[],
            CantidadOperacionBAsisC:[],
            TotalMes:0,
            TotalEjecutivos:0,
            TotalBssEjecutivos:0,
            TotalLlamadasEjecutivos:0,
            
        }
    },
    created () {
        this.select();    
        this.fechahoy();    
        this.generarListaAnios();
    },
    computed: {
        computedDateFormattedInicio () {
            return this.formatDate(this.dateInicio)
        },
        computedDateFormattedFin () {
            return this.formatDate(this.dateFin)
        },
        computedDateFormatrecei () { 
            return this.formatDate(this.dateval)
      },
    },
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },
    methods:{
        generarListaAnios() {
            const anioInicioSistema = 2021; 
            const anioActual = new Date().getFullYear();
            this.listaAnios = [];
            for (let i = anioActual; i >= anioInicioSistema; i--) {
                this.listaAnios.push({ text: String(i), value: i });
            }
        },
        
        EjecutarComparativa() {
        if(this.aniosSeleccionados.length === 0) {
            alert("Por favor, selecciona al menos un año.");
            return;
        }
        this.aniosSeleccionados.sort((a, b) => a - b);
        this.cantidadaños = this.aniosSeleccionados.length - 1; 
        this.GenerarReporte();
        },
        async GenerarReporte() {
            let me = this;
            let header = {"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion = {headers: header};
            
            var reportemes = [];
            var reportemesactividades = [];
            var reportemesactividadesc = [];
            
            me.reportecompleto = [];
            me.datosCrudosVentas = []; 
            me.años = [];
            me.profitusuarios = [];
            me.TipoOperacionC = [];
            me.TipoOperacionAC = [];
            me.profitbasis = [];
            me.usuariosReporte = [];
            me.ReporteporCliente = [];
            me.ListadoClientes = [];
            me.actividadesusuario = [];
            me.usuariosReporteActividad = [];
            me.usuariosReporteActividadc = [];
            me.actividadesusuarioc = [];
            
            me.kpiVentasActual = 0;
            me.kpiVentasAnterior = 0;
            me.kpiBsActual = 0;
            me.kpiBsAnterior = 0;
            
            me.dialodload = true;
            me.verreporte = false;
            var entratotal = false; 

            let tempHistoricoVentas = {};
            let tempHistoricoBs = {};

            let aniosAAnalizar = [...this.aniosSeleccionados].sort((a,b) => a - b);
            
            me.anioMasReciente = aniosAAnalizar[aniosAAnalizar.length - 1];
            me.anioAnterior = aniosAAnalizar.length > 1 ? aniosAAnalizar[aniosAAnalizar.length - 2] : null;

            for (let i = 0; i < aniosAAnalizar.length; i++) {
                let añoactual = aniosAAnalizar[i];
                me.años.push({text: String(añoactual)});                             
                
                await axios.get('api/Oscars/ReporteProfitPormes/' + añoactual, configuracion).then(function(response){
                    reportemes = response.data;
                    
                    if (me.mesSeleccionado) {
                        reportemes = reportemes.filter(item => {
                            if(!item.fechacreate) return false;
                            let mesItem = new Date(item.fechacreate).getMonth() + 1;
                            return mesItem === me.mesSeleccionado;
                        });
                    }
                    
                    me.datosCrudosVentas = me.datosCrudosVentas.concat(reportemes);
                    
                    me.headerreportemes = [{text:'Mes',value:'mes'}];
                    var año = añoactual;
                    
                    me.enero = 0; me.febrero = 0; me.marzo = 0; me.abril = 0;
                    me.mayo = 0; me.junio = 0; me.julio = 0; me.agosto = 0;
                    me.septiembre = 0; me.octubre = 0; me.noviembre = 0; me.diciembre = 0;
                    me.TotalMes = 0;

                                let nuevoObjeto = {}
                                let Objetobasis = {}
                                let Objetocliente = {}
                                var nuevous = [];
                            
                                reportemes.map(function(x){
                                    if( !nuevoObjeto.hasOwnProperty(x.idusuario)){
                                        nuevoObjeto[x.idusuario] = { profitejecutivo: [] }                                                                                                              
                                    }                  
                                    nuevoObjeto[x.idusuario].profitejecutivo.push({
                                        profitt: x.profitt,
                                        idusuario: x.idusuario,
                                        fechacreate:x.fechacreate,
                                        nusuario:x.nusuario
                                    })
                                    if( !Objetobasis.hasOwnProperty(x.idbasis)){
                                        Objetobasis[x.idbasis] = { profitbasis: [] }                                                                                                              
                                    }                  
                                    Objetobasis[x.idbasis].profitbasis.push({
                                        profitt: x.profitt,
                                        nbasis:x.nbasis,
                                        idtipoOp:x.idtipoOp,
                                        ntipoOp:x.ntipoOp,
                                        fechacreate:x.fechacreate,
                                        idbasis:x.idbasis,
                                        nbuysell:x.nbuysell,
                                    });
                                    if( !Objetocliente.hasOwnProperty(x.idcustumer)){
                                        Objetocliente[x.idcustumer] = { profitcliente: [] }                                                                                                              
                                    }                  
                                    Objetocliente[x.idcustumer].profitcliente.push({
                                        profitt: x.profitt,
                                        nbasis:x.nbasis,
                                        idbasis:x.idbasis,
                                        idtipoOp:x.idtipoOp,
                                        ntipoOp:x.ntipoOp,
                                        fechacreate:x.fechacreate,
                                        idcustumer:x.idcustumer,
                                        ncustumer:x.ncustumer,
                                        nusuario:x.nusuario,
                                        receipt:x.receipt,
                                        loading:x.loading,
                                        discharge:x.discharge,
                                        delivery:x.delivery,
                                        commodity:x.commodity,
                                    });

                                    var mes = 0;
                                    var day = new Date(x.fechacreate);
                                    año = day.getFullYear();
                                    mes = day.getMonth() + 1;

                                    if(mes == 1){ me.enero = me.enero + x.profitt; }
                                    if(mes == 2){ me.febrero = me.febrero + x.profitt; }
                                    if(mes == 3){ me.marzo = me.marzo + x.profitt; }
                                    if(mes == 4){ me.abril = me.abril + x.profitt; }
                                    if(mes == 5){ me.mayo = me.mayo + x.profitt; }
                                    if(mes == 6){ me.junio = me.junio + x.profitt; }
                                    if(mes == 7){ me.julio = me.julio + x.profitt; }
                                    if(mes == 8){ me.agosto = me.agosto + x.profitt; }
                                    if(mes == 9){ me.septiembre = me.septiembre + x.profitt; }
                                    if(mes == 10){ me.octubre = me.octubre + x.profitt; }
                                    if(mes == 11){ me.noviembre = me.noviembre + x.profitt; }
                                    if(mes == 12){ me.diciembre = me.diciembre + x.profitt; }
                                    
                                    me.TotalMes = me.TotalMes + x.profitt;
                                    tempHistoricoVentas[año] = (tempHistoricoVentas[año] || 0) + x.profitt;
                                    tempHistoricoBs[año] = (tempHistoricoBs[año] || 0) + 1;
                                    
                                    if (me.anioAnterior && año === me.anioAnterior) {
                                        me.kpiVentasAnterior += x.profitt;
                                        me.kpiBsAnterior += 1;
                                    }
                                });                    
                                
                                var profit = 0;
                                me.TotalEjecutivos = 0;
                                me.TotalBssEjecutivos = 0;
                                me.ejecutivos.map(function(x){
                                    var profitus = 0;
                                    var nusuario = '';
                                    var idusuario = 0;
                                    var bs = 0;
                                    if(nuevoObjeto[x.value] != undefined){
                                        nuevoObjeto[x.value].profitejecutivo.map(function(y){
                                            profitus = profitus + y.profitt;
                                            nusuario = y.nusuario;
                                            idusuario = y.idusuario;
                                            bs = bs +1;
                                            me.TotalEjecutivos = me.TotalEjecutivos + y.profitt;
                                            me.TotalBssEjecutivos = me.TotalBssEjecutivos + 1;
                                        });
                                        me.profitusuarios.push({
                                            text:nusuario,
                                            profitt:profitus,
                                            año:año,
                                            value:idusuario,
                                            bs:bs,
                                        });
                                        if(!me.usuariosReporte.find((usuario) => usuario.text === nusuario)){
                                            me.usuariosReporte.push({text:nusuario,value:idusuario})
                                        }
                                    }
                                })
                                
                                me.profitusuarios.push({
                                    text:'Total',
                                    profitt:me.TotalEjecutivos,
                                    año:año,
                                    value:-1,
                                    bs:me.TotalBssEjecutivos,
                                });
                            
                                var ttotal = 0;
                                    var nbs = 0;
                                    me.basis.map(function(x){                        
                                    if(Objetobasis[x.value] != undefined){
                                        var nbasis = '';
                                        var idbasis = 0;
                                        var ntipoOp = '';
                                        var idtipoOp = 0;                            
                                        
                                        me.TipoOperacion.map(function(o){
                                            var profitbasis = 0;
                                            nbs = 0;
                                            Objetobasis[x.value].profitbasis.map(function(y){
                                                if(o.value == y.idtipoOp){
                                                    profitbasis = profitbasis + y.profitt;
                                                    nbasis = y.nbasis;
                                                    idbasis = y.idbasis;
                                                    ntipoOp = y.ntipoOp;
                                                    idtipoOp = y.idtipoOp;
                                                    nbs = nbs +1;   
                                                }
                                            });
                                            if(!me.TipoOperacionC.find((tipoOp) => tipoOp.text === nbasis +' '+ ntipoOp)){                                 
                                                me.TipoOperacionC.push({text:nbasis + ' '+ ntipoOp ,value:idbasis, idtipoOp:idtipoOp})                                    
                                            }
                                            if(!me.profitbasis.find((profitT) => profitT.text === nbasis +' '+ ntipoOp && profitT.año === año)){                   
                                                me.profitbasis.push({
                                                    text:nbasis +' '+ ntipoOp,
                                                    profitbasis:profitbasis,
                                                    bs:nbs,
                                                    idtipoOp:idtipoOp,
                                                    ntipoOp:ntipoOp,
                                                    value:idbasis,
                                                    año:año,
                                                });
                                                ttotal = ttotal + profitbasis;
                                            }
                                        });                                                                                
                                    }
                                });
                                
                                me.customer.map(function(c){
                                        if(Objetocliente[c.value] != undefined){
                                            var profitaño = 0;
                                            var idcustumer = 0;
                                            var ejecutivo = '';
                                            var ejecutivoall = '';
                                            var typeOP = [];
                                            var ntipoOp = '';
                                            var basis = [];
                                            var nbasis = '';
                                            var pol = [];
                                            var npol = '';
                                            var npod = '';
                                            var pod = [];
                                            var ncustumer = '';
                                            var commodity = '';
                                            var com = [];
                                            
                                            Objetocliente[c.value].profitcliente.map(function(y){
                                                profitaño = profitaño + y.profitt;
                                                idcustumer = y.idcustumer;
                                                ncustumer = y.ncustumer;
                                                if(ejecutivo != y.nusuario){
                                                    ejecutivo = y.nusuario;
                                                    ejecutivoall = ejecutivoall + y.nusuario; 
                                                }
                                                if(!typeOP.find((tipoOp) => tipoOp.text === y.ntipoOp)){
                                                    typeOP.push({text:y.ntipoOp,value:y.idtipoOp})
                                                    if(ntipoOp == ''){
                                                        ntipoOp = y.ntipoOp;
                                                    }else{
                                                        ntipoOp = ntipoOp + ' / ' + y.ntipoOp;
                                                    }
                                                    
                                                }
                                                if(!basis.find((basisn) => basisn.text === y.nbasis)){
                                                    basis.push({text:y.nbasis,value:y.idbasis})
                                                    if(nbasis == ''){
                                                        nbasis = y.nbasis;
                                                    }else{
                                                        nbasis = nbasis + ' / ' + y.nbasis;
                                                    }
                                                    
                                                }
                                                if(y.loading != 'SELECT..' ){
                                                    if(!pol.find((poln) => poln.text === y.loading)){
                                                        pol.push({text:y.loading})
                                                        if(npol == ''){
                                                            npol = y.loading;
                                                        }else{
                                                            npol = npol + ' /-/ ' + y.loading;
                                                        }                                          
                                                    }                                                                               
                                                }
                                                if(y.receipt != 'SELECT..' ){
                                                    if(!pol.find((poln) => poln.text === y.receipt)){
                                                        pol.push({text:y.receipt})
                                                        if(npol == ''){
                                                            npol = y.receipt;
                                                        }else{
                                                            npol = npol + ' /-/ ' + y.receipt;
                                                        }                                          
                                                    }                                                                               
                                                }
                                                if(y.discharge != 'SELECT..' ){
                                                    if(!pod.find((podn) => podn.text === y.discharge)){
                                                        pod.push({text:y.discharge})
                                                        if(npod == ''){
                                                            npod = y.discharge;
                                                        }else{
                                                            npod = npod + ' /-/ ' + y.discharge;
                                                        }                                          
                                                    }                                                                               
                                                }
                                                if(y.delivery != 'SELECT..' ){
                                                    if(!pod.find((podn) => podn.text === y.delivery)){
                                                        pod.push({text:y.delivery})
                                                        if(npod == ''){
                                                            npod = y.delivery;
                                                        }else{
                                                            npod = npod + ' /-/ ' + y.delivery;
                                                        }                                          
                                                    }                                                                               
                                                }
                                                if(!com.find((comm) => comm.text === y.commodity)){
                                                    com.push({text:y.commodity})
                                                    if(commodity == ''){
                                                        commodity = y.commodity;
                                                    }else{
                                                        commodity = commodity + ' /-/ ' + y.commodity;
                                                    }                                          
                                                }
                                            });
                                            if(!me.ListadoClientes.find((cliente) => cliente.text === ncustumer)){
                                                me.ListadoClientes.push({
                                                    text:ncustumer,
                                                    value:idcustumer,
                                                    ejecutivoall:ejecutivoall,
                                                    ntipoOp:ntipoOp,
                                                    nbasis:nbasis,
                                                    npol:npol,
                                                    npod:npod,
                                                    commodity:commodity,
                                                });
                                            } 
                                            me.ReporteporCliente.push(
                                            {
                                                profitaño:profitaño,
                                                año:año,
                                                value:idcustumer,
                                                ejecutivoall:ejecutivoall
                                            });
                                        }                            
                                    })

                                me.reportecompleto.push(
                                    {text:me.enero,value:1,año:año},
                                    {text:me.febrero,value:2,año:año},
                                    {text:me.marzo,value:3,año:año},
                                    {text:me.abril,value:4,año:año},
                                    {text:me.mayo,value:5,año:año},
                                    {text:me.junio,value:6,año:año},
                                    {text:me.julio,value:7,año:año},
                                    {text:me.agosto,value:8,año:año},
                                    {text:me.septiembre,value:9,año:año},
                                    {text:me.octubre,value:10,año:año},
                                    {text:me.noviembre,value:11,año:año},
                                    {text:me.diciembre,value:12,año:año},
                                    {text:me.TotalMes,value:13,año:año},
                                );
                            
                                if(entratotal == false && i === aniosAAnalizar.length - 1){
                                    const rta = me.usuariosReporte.sort((c, d)=> c.text.toLowerCase().charCodeAt(0) - d.text.toLowerCase().charCodeAt(0))
                                    me.usuariosReporte.push({text:'Total',value:-1})
                                    entratotal = true;
                                }

                            }).catch(function(error){
                                console.log(error);
                            });

                            await axios.get('api/Actividades/ReporteActividadesA/' + añoactual,configuracion).then(function(response){
                                reportemesactividades = response.data;
                                let nuevoObjetoActividad= {};
                                reportemesactividades.map(function(y){
                                    if( !nuevoObjetoActividad.hasOwnProperty(y.idusuario)){
                                        nuevoObjetoActividad[y.idusuario] = {
                                            actividadesjecutivo: []
                                        }                                                                                                              
                                    }                  
                                    nuevoObjetoActividad[y.idusuario].actividadesjecutivo.push({
                                        idtipo_actividad: y.idtipo_actividad,
                                        idusuario: y.idusuario,
                                        fechaactividad1:y.fechaactividad1,
                                    })
                                });
                                me.ejecutivos.map(function(z){
                                    me.TotalLlamadasEjecutivos = 0;
                                    var nusuario = '';
                                    var idusuario = 0;
                                    var llamadas = 0;
                                    var añoa = 0;
                                    if(nuevoObjetoActividad[z.value] != undefined){
                                        nuevoObjetoActividad[z.value].actividadesjecutivo.map(function(y){
                                            var day = new Date(y.fechaactividad1);
                                            añoa = day.getFullYear();
                                            if(y.idtipo_actividad == 2){
                                                llamadas = llamadas + 1;
                                                me.TotalLlamadasEjecutivos = me.TotalLlamadasEjecutivos + 1;
                                            }
                                            idusuario = y.idusuario;
                                            nusuario = z.text;
                                        });
                                        me.actividadesusuario.push(
                                            {
                                                value:idusuario,
                                                llamadas:llamadas,
                                                año:añoa,
                                                TotalLlamadasEjecutivos:me.TotalLlamadasEjecutivos
                                            }
                                        );
                                        if(!me.usuariosReporteActividad.find((usuario) => usuario.value === idusuario)){
                                            me.usuariosReporteActividad.push({text:nusuario,value:idusuario})
                                        }
                                    }
                                })
                                
                            }).catch(function(error){
                                console.log(error);
                            });

                            await axios.get('api/Cotizaciones/ReporteListarcotizacion/' + añoactual,configuracion).then(function(response){
                                reportemesactividadesc = response.data;  
                                let nuevoObjetoActividadc = {};
                                let Objetobasisc = {};                    
                                var añoac = 0;

                                reportemesactividadesc.map(function(y){
                                    var day = new Date(y.fechsend);
                                    añoac = day.getFullYear();

                                    if( !nuevoObjetoActividadc.hasOwnProperty(y.idusuario)){
                                        nuevoObjetoActividadc[y.idusuario] = { actividadesjecutivoc: [] }                                                                                                              
                                    }                  
                                    nuevoObjetoActividadc[y.idusuario].actividadesjecutivoc.push({
                                        idusuario: y.idusuario,
                                        create:y.fechsend,
                                    });
                                    if( !Objetobasisc.hasOwnProperty(y.basis)){
                                        Objetobasisc[y.basis] = { reportebasisc: [] }                                                                                                              
                                    }                  
                                    Objetobasisc[y.basis].reportebasisc.push({
                                        idusuario:y.idusuario,
                                        idbasis:y.basis,
                                        nbasis:y.nbasis,
                                        ntipoOp:y.ntipoOp,
                                        idtipoOp:y.idtipoOp,
                                        año:añoac,
                                    });
                                });

                                me.ejecutivos.map(function(z){
                                    var nusuario = '';
                                    var idusuario = 0;
                                    var cotizaciones = 0;
                                    var añoc = 0;
                                    var totalcotizaciones = 0;
                                    
                                    if(nuevoObjetoActividadc[z.value] != undefined){
                                        nuevoObjetoActividadc[z.value].actividadesjecutivoc.map(function(f){
                                            var day = new Date(f.create);
                                            añoc = day.getFullYear();
                                            cotizaciones = cotizaciones + 1;
                                            totalcotizaciones = totalcotizaciones + 1;
                                            idusuario = f.idusuario;
                                            nusuario = z.text;
                                        });
                                        me.actividadesusuarioc.push({
                                                value:idusuario,
                                                cotizaciones:cotizaciones,
                                                año:añoc,
                                                totalcotizaciones:totalcotizaciones
                                        });
                                        if(!me.usuariosReporteActividadc.find((usuario) => usuario.value === idusuario)){
                                            me.usuariosReporteActividadc.push({text:nusuario,value:idusuario})
                                        }
                                    }
                                });
                                var nbs = 0;
                                me.basis.map(function(x){
                                    var totalcotizacionesbasis = 0;
                                    if(Objetobasisc[x.value] != undefined){
                                        var nbasis = '';
                                        var idbasis = 0;
                                        var ntipoOp = '';
                                        var idtipoOp = 0;                            
                                        var cuenta = 0
                                        me.TipoOperacion.map(function(o){
                                            nbs = 0;
                                            cuenta = 0
                                            var año;
                                            Objetobasisc[x.value].reportebasisc.map(function(g){
                                                
                                                if(g.idbasis == x.value && g.idtipoOp == o.value){
                                                    cuenta = cuenta + 1;
                                                    nbasis = g.nbasis;
                                                    ntipoOp = g.ntipoOp;
                                                    idtipoOp = g.idtipoOp;
                                                    idbasis = g.idbasis;
                                                    año = g.año;
                                                    totalcotizacionesbasis = totalcotizacionesbasis + 1;
                                                }
                                            });
                                            if(!me.TipoOperacionAC.find((tipoOp) => tipoOp.text === nbasis +' '+ ntipoOp)){                                 
                                                me.TipoOperacionAC.push({text:nbasis + ' '+ ntipoOp ,value:idbasis, idtipoOp:idtipoOp})
                                            }
                                            if(!me.CantidadOperacionBAsisC.find((tipoBasis) => tipoBasis.text === nbasis +' '+ ntipoOp && tipoBasis.año === año)){
                                                me.CantidadOperacionBAsisC.push({
                                                    text: nbasis + ' '+ ntipoOp,
                                                    value:idbasis,
                                                    idtipoOp:idtipoOp,
                                                    cuenta:cuenta,
                                                    año: año,
                                                    totalcotizacionesbasis:totalcotizacionesbasis
                                                });
                                            } 
                                        });                                                        
                                    }
                                });
                                
                            }).catch(function(error){
                                console.log(error);
                            });                    
                        me.cantidadaños = 0;
                        if(i === aniosAAnalizar.length - 1){

                            // LOGICA NUEVA PARA PESTAÑA DE ESTACIONALIDAD AGRUPADA
                            let clientGlobalTotal = {};
                            me.datosCrudosVentas.forEach(x => {
                                if(!x.fechacreate || !x.ncustumer) return;
                                let cliente = x.ncustumer;
                                clientGlobalTotal[cliente] = (clientGlobalTotal[cliente] || 0) + x.profitt;
                            });

                            let mapClientesData = {};
                            me.datosCrudosVentas.forEach(x => {
                                if(!x.fechacreate || !x.ncustumer) return;
                                let mes = new Date(x.fechacreate).getMonth() + 1;
                                let year = new Date(x.fechacreate).getFullYear();
                                let cliente = x.ncustumer;

                                if(!mapClientesData[cliente]) {
                                    mapClientesData[cliente] = {
                                        nombre: cliente,
                                        globalTotal: clientGlobalTotal[cliente],
                                        yearsData: {}
                                    };
                                }
                                
                                if(!mapClientesData[cliente].yearsData[year]) {
                                    mapClientesData[cliente].yearsData[year] = {
                                        year: year,
                                        1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0,
                                        total: 0
                                    };
                                }
                                
                                mapClientesData[cliente].yearsData[year][mes] += x.profitt;
                                mapClientesData[cliente].yearsData[year].total += x.profitt;
                            });

                            me.rentabilidadClienteMes = Object.values(mapClientesData).map(cliente => {
                                cliente.yearsArray = Object.values(cliente.yearsData).sort((a, b) => a.year - b.year);
                                return cliente;
                            }).sort((a,b) => b.globalTotal - a.globalTotal);

                            me.dialodload = false;
                            me.verreporte = true;

                            me.kpiHistoricoVentas = tempHistoricoVentas;
                            me.kpiHistoricoBs = tempHistoricoBs;
                            
                            me.kpiVentasActual = me.kpiHistoricoVentas[me.anioMasReciente] || 0;
                            me.kpiVentasAnterior = me.anioAnterior ? (me.kpiHistoricoVentas[me.anioAnterior] || 0) : 0;
                            
                            me.kpiBsActual = me.kpiHistoricoBs[me.anioMasReciente] || 0;
                            me.kpiBsAnterior = me.anioAnterior ? (me.kpiHistoricoBs[me.anioAnterior] || 0) : 0;
                        }               
                    }                
                },
        
        getNombreMes(m) {
            const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            return meses[m-1];
        },

        getBestMonth(itemYear) {
            let bestMonth = 1;
            let maxVal = itemYear[1] || 0;
            for(let i = 2; i <= 12; i++) {
                if((itemYear[i] || 0) > maxVal) {
                    maxVal = itemYear[i];
                    bestMonth = i;
                }
            }
            return maxVal > 0 ? bestMonth : null;
        },

        exportExcelEstacionalidad: function () {
            if(!this.rentabilidadClienteMes || this.rentabilidadClienteMes.length === 0) {
                alert("No hay datos para exportar");
                return;
            }
            
            var dataToExport = [];
            
            this.rentabilidadClienteMes.forEach(c => {
                c.yearsArray.forEach((itemYear, index) => {
                    var bestM = this.getBestMonth(itemYear);
                    var bestMonthName = bestM ? this.getNombreMes(bestM) : 'N/A';
                    var bestMonthVal = bestM ? itemYear[bestM] : 0;

                    dataToExport.push({
                        "Cliente": index === 0 ? c.nombre : "", 
                        "Año": itemYear.year,
                        "Enero": parseFloat((itemYear[1] || 0).toFixed(2)),
                        "Febrero": parseFloat((itemYear[2] || 0).toFixed(2)),
                        "Marzo": parseFloat((itemYear[3] || 0).toFixed(2)),
                        "Abril": parseFloat((itemYear[4] || 0).toFixed(2)),
                        "Mayo": parseFloat((itemYear[5] || 0).toFixed(2)),
                        "Junio": parseFloat((itemYear[6] || 0).toFixed(2)),
                        "Julio": parseFloat((itemYear[7] || 0).toFixed(2)),
                        "Agosto": parseFloat((itemYear[8] || 0).toFixed(2)),
                        "Septiembre": parseFloat((itemYear[9] || 0).toFixed(2)),
                        "Octubre": parseFloat((itemYear[10] || 0).toFixed(2)),
                        "Noviembre": parseFloat((itemYear[11] || 0).toFixed(2)),
                        "Diciembre": parseFloat((itemYear[12] || 0).toFixed(2)),
                        "TOTAL AÑO": parseFloat((itemYear.total || 0).toFixed(2)),
                        "Mejor Mes": bestMonthName + " ($" + parseFloat(bestMonthVal).toFixed(2) + ")"
                    });
                });
            });

            var libreriaExcel = window.XLSX || XLSX; 
            var data = libreriaExcel.utils.json_to_sheet(dataToExport);
            var workbook = libreriaExcel.utils.book_new();
            var nombreArchivo = 'Estacionalidad_Clientes_' + this.fechaHoyN;
            
            libreriaExcel.utils.book_append_sheet(workbook, data, 'Estacionalidad');
            libreriaExcel.writeFile(workbook, nombreArchivo + '.xlsx');
        },

        // CALCULO Y APERTURA DE MODAL POR MES Y EJECUTIVO
        AbrirDetalleMes(mesObj) {
            this.mesSeleccionadoModal = mesObj;
            let breakdown = {};
            
            this.usuariosReporte.forEach(u => {
                if (u.value !== -1) {
                    breakdown[u.value] = { nombre: u.text };
                    this.años.forEach(a => { breakdown[u.value][a.text] = 0; });
                }
            });

            let registrosMes = this.datosCrudosVentas.filter(x => {
                if(!x.fechacreate) return false;
                return (new Date(x.fechacreate).getMonth() + 1) === mesObj.value;
            });

            registrosMes.forEach(x => {
                let year = String(new Date(x.fechacreate).getFullYear());
                if (breakdown[x.idusuario] && breakdown[x.idusuario][year] !== undefined) {
                    breakdown[x.idusuario][year] += x.profitt;
                }
            });

            this.datosMesEjecutivo = Object.values(breakdown).sort((a, b) => a.nombre.localeCompare(b.nombre));
            this.modalMesEjecutivo = true;
        },

        // TENDENCIA ESPECIAL DEL MODAL
        getModalTrend(item, currentYear, prevYear) {
            let vC = parseFloat(item[currentYear]) || 0;
            let vP = parseFloat(item[prevYear]) || 0;

            if (vC === 0 && vP === 0) return null; 

            if (vP === 0 && vC > 0) return { icon: 'arrow_upward', color: '#059669', bg: '#d1fae5', pct: '100.0' };
            if (vP === 0 && vC < 0) return { icon: 'arrow_downward', color: '#e11d48', bg: '#ffe4e6', pct: '100.0' };
            if (vC === vP) return { icon: 'drag_handle', color: '#64748b', bg: '#f1f5f9', pct: '0.0' };

            let pct = ((vC - vP) / Math.abs(vP)) * 100;
            if (pct > 0) return { icon: 'arrow_upward', color: '#059669', bg: '#d1fae5', pct: pct.toFixed(1) };
            return { icon: 'arrow_downward', color: '#e11d48', bg: '#ffe4e6', pct: Math.abs(pct).toFixed(1) };
        },

        // CALCULO DE TENDENCIA TABLAS NORMALES
        getTrendData(dataset, keyName, idValue, year, prevYear, valField, extraKey = null, extraVal = null, divideByField = null) {
            if (!prevYear || year === 'Total' || prevYear === 'Total') return null;
            
            let curr = dataset.find(x => x[keyName] === idValue && String(x.año) === String(year) && (extraKey ? x[extraKey] === extraVal : true));
            let prev = dataset.find(x => x[keyName] === idValue && String(x.año) === String(prevYear) && (extraKey ? x[extraKey] === extraVal : true));

            let vC = curr ? parseFloat(curr[valField]) || 0 : 0;
            let vP = prev ? parseFloat(prev[valField]) || 0 : 0;

            if (divideByField) {
                let currDiv = curr ? parseFloat(curr[divideByField]) || 1 : 1;
                let prevDiv = prev ? parseFloat(prev[divideByField]) || 1 : 1;
                vC = currDiv === 0 ? 0 : (vC / currDiv);
                vP = prevDiv === 0 ? 0 : (vP / prevDiv);
            }

            if (vC === 0 && vP === 0) return null; 

            if (vP === 0 && vC > 0) return { icon: 'arrow_upward', color: '#059669', bg: '#d1fae5', pct: '100.0' };
            if (vP === 0 && vC < 0) return { icon: 'arrow_downward', color: '#e11d48', bg: '#ffe4e6', pct: '100.0' };
            if (vC === vP) return { icon: 'drag_handle', color: '#64748b', bg: '#f1f5f9', pct: '0.0' };

            let pct = ((vC - vP) / Math.abs(vP)) * 100;
            if (pct > 0) return { icon: 'arrow_upward', color: '#059669', bg: '#d1fae5', pct: pct.toFixed(1) };
            return { icon: 'arrow_downward', color: '#e11d48', bg: '#ffe4e6', pct: Math.abs(pct).toFixed(1) };
        },

        calcularPorcentaje(actual, anterior) {
            if (!anterior || anterior === 0) return '100.00';
            let diferencia = ((actual - anterior) / anterior) * 100;
            return Math.abs(diferencia).toFixed(1);
        },
        /********************************************************** */
        select(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var usuariosarray = [];
            var basiss = [];
            var tipoOp = [];
            var customerArray = [];
            axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                customerArray=response.data;
                customerArray.map(function(x){
                    me.customer.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Tipooperaciones/Select',configuracion).then(function(response){            
                tipoOp=response.data;
                tipoOp.map(function(x){
                    me.TipoOperacion.push({text:x.nombre,value:x.idtipoOp});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Usuarios/SelectAdminC',configuracion).then(function(response){
                usuariosarray=response.data;
                usuariosarray.map(function(x){
                    me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            });
            me.ejecutivos.push({text:'Total',value:-1})
            axios.get('api/Basis/Select',configuracion).then(function(response){            
                basiss=response.data;
                basiss.map(function(x){
                    me.basis.push({text:x.nombre,value:x.idbasis});
                });            
            }).catch(function(error){
            console.log(error);
            });
        },
        ContarActividades(){
            this.dialodload = true;
            this.DetallesCotizaciones = false;
            this.DetallesBs = false;
            let me=this; 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var events = [];
            me.COT = 0;
            me.SLC = 0;
            me.LLS = 0;
            me.VentaTotal = 0;
            me.BS = 0;
            me.BSC = 0;
            me.TotalProfit = 0;

            axios.get('api/Actividades/ReporteActividades/' + me.idejecutivo + '/' + me.dateInicio + '/' + me.dateFin,configuracion).then(function(response){
                events=response.data;                
                me.COT = 0;
                me.SLC = 0;
                me.LLS = 0;
                var diasSemana = new Array("Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"); 
                events.map(function(x){
                    if(x.clave_actividad == 'SLC'){
                        me.SLC = me.SLC + 1;
                    }
                    if(x.clave_actividad == 'LLS'){
                        me.LLS = me.LLS + 1;
                    }
                })
                me.ContarBS();
            }).catch(function(error){
                console.log(error);
            });
        },
        ContarBS(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.BuySellLista = [];
            axios.get('api/Oscars/RepoteUsuarioBs/' + me.idejecutivo + '/'+ me.dateInicio + '/' + me.dateFin,configuracion).then(function(response){      
                me.BuySellLista = response.data;
                me.BS = me.BuySellLista.length;
                me.BuySellLista.map(function(x){
                    me.VentaTotal = me.VentaTotal + x.profitt;
                })
                me.ContarBSCanceladas();
            }).catch(function(error){
                console.log(error);
            });
        },
        ContarBSCanceladas(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.BuySellListac = [];

            axios.get('api/Buysells/ReporteTargetCanceladas/' + me.idejecutivo + '/' + me.dateInicio + '/' + me.dateFin,configuracion).then(async function(response){                
                me.BuySellListac = response.data;
                me.BSC = me.BuySellListac.length;
                me.detalleCot();
            }).catch(function(error){
                console.log(error);
            });
        },
        detalleCot(){
            let me=this; 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.CotizacionesDatos = [];
            var cotizaciones = [];
            axios.get('api/Cotizaciones/ReporteListarcotizacion/'+ me.idejecutivo + '/' + me.dateInicio + '/' + me.dateFin,configuracion).then(function(response){                
                me.cotizaciones = response.data;
                console.log(me.cotizaciones)
                me.COT = me.cotizaciones.length;
                me.cotizaciones.map(function(x){
                    me.CotizacionesDatos.push({
                        EJECUTIVO:x.nusuario,
                        NUMERO_COTIZACION:x.ncotizacion,
                        CLIENTE:x.ncustumer,
                        MODALIDAD:x.modalidad,
                        MOVIMIENTO:x.movimiento,
                        PRODUCTO:x.producto,
                        ORIGEN:x.origen,
                        DESTINO:x.destino,
                        SERVICIO:x.servicio,
                        TT:x.tt,
                    });
                })
                me.dialodload = false;
            }).catch(function(error){
                console.log(error);
                me.dialodload = false;
            });
        },
        detalleSol(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.SolicitudT = [];
            var sol = [];
            var tarifa = [];
            var SolicitusLista = [];
            axios.get('api/Scotizaciones/ListarScotizacionDasboard/'+ me.idejecutivo + '/' + me.dateInicio + '/' + me.dateFin,configuracion).then(async function(response){
                sol = response.data;
                var n = 0;
                for(var i = 0; i < sol.length; i++){
                    var principal = false;
                    var principalstatus = false;
                    var recollecion = false;
                    var recollecionstatus = false;
                    var entrega = false;
                    var entregastatus = false;
                    var viewextra = false;
                    var statusadicional = false;
                    var notificaAgente = false;
                    var notificaPricing = false;
                    var notificaLocal = false;
                    if(sol[i].principalratePricing == true || sol[i].principalrateLocal == true || sol[i].principalrateAgents == true){
                        principal = true;
                        if(sol[i].statusPrincipalRatePricing == true || sol[i].statusPrincipalRateLocal == true || sol[i].statusPrincipalRateAgents == true){
                            principalstatus = true;
                        }
                    }
                    if(sol[i].pickupLocal == true || sol[i].pickupAgents == true || sol[i].pickupPricing == true){
                        recollecion = true;
                        if(sol[i].statusPickupPricing == true || sol[i].statusPickupLocal == true || sol[i].statusPickupAgents == true){
                            recollecionstatus = true;
                        }
                    }
                    if(sol[i].deliveryAgents == true || sol[i].deliveryLocal == true || sol[i].deliveryPricing == true){
                        entrega = true;
                        if(sol[i].statusDeliveryLocal == true || sol[i].statusDeliveryAgents == true || sol[i].statusDeliveriPricing == true){
                            entregastatus = true;
                        }
                    }
                    if(sol[i].maneuvers == true || sol[i].vgm == true || sol[i].insurance == true || sol[i].custody == true || sol[i].custom == true){
                        viewextra = true;
                        statusadicional = sol[i].statusAdicional;
                    }
                    if(sol[i].principalrateAgents == true || sol[i].pickupAgents == true || sol[i].deliveryAgents == true){
                        notificaAgente = true;
                    }
                    if(sol[i].pickupPricing == true || sol[i].principalratePricing == sol || sol[i].deliveryPricing == true){
                        notificaPricing = true;
                    }
                    if(sol[i].pickupLocal == true || sol[i].principalrateLocal == true || sol[i].deliveryLocal == true){
                        notificaLocal = true;
                    }
                    var nfecharespuesta = '';
                    if(sol[i].nfecharespuesta == '01/01/1753 12:00 a. m.'){
                        nfecharespuesta = 'Pendiente';
                    }else{
                        nfecharespuesta = sol[i].nfecharespuesta;
                    }
                    SolicitusLista.push({
                        agente:sol[i].agente, basis:sol[i].basis, clas:sol[i].clas, comodity:sol[i].comodity, custody:sol[i].custody,
                        custom:sol[i].custom, delivery:sol[i].delivery, dentrofbl:sol[i].dentrofbl, direcciondeliverypcompleta:sol[i].direcciondeliverypcompleta,
                        direccionreceipcompleta:sol[i].direccionreceipcompleta, fechacreate:sol[i].fechacreate, fechaedit:sol[i].fechaedit,
                        fecharespuesta:sol[i].fecharespuesta, filehazardous:sol[i].filehazardous, foodgrade:sol[i].foodgrade, freedaysdest:sol[i].freedaysdest,
                        freedaysorigin:sol[i].freedaysorigin, hazardous:sol[i].hazardous, idbasis:sol[i].idbasis, idcustumer:sol[i].idcustumer, idinland:sol[i].idinland,
                        idlistatarifa:sol[i].idlistatarifa, idportdelivery:sol[i].idportdelivery, idportdischarge:sol[i].idportdischarge, idportloading:sol[i].idportloading,
                        idportreceipt:sol[i].idportreceipt, idscotizacion:sol[i].idscotizacion, idtipoOp:sol[i].idtipoOp, idusuario:sol[i].idusuario, insurance:sol[i].insurance,
                        local:sol[i].local, maneuvers:sol[i].maneuvers, ncotizacion:sol[i].ncotizacion, ncustumer:sol[i].ncustumer, nfechacreate:sol[i].nfechacreate,
                        nfechaedit:sol[i].nfechaedit, nfecharespuesta:nfecharespuesta, npuertodelivery:sol[i].npuertodelivery, npuertodischarge:sol[i].npuertodischarge,
                        npuertoloading:sol[i].npuertoloading, npuertoreceipt:sol[i].npuertoreceipt, nusuario:sol[i].nusuario, pickup:sol[i].pickup, pricing:sol[i].pricing,
                        remarks:sol[i].remarks, status:sol[i].status, tarifaadicional:sol[i].tarifaadicional, tarifaprincipal:sol[i].tarifaprincipal, tipoOp:sol[i].tipoOp,
                        un:sol[i].un, vgm:sol[i].vgm, entrega:entrega, recollecion:recollecion, principal:principal, recollecionstatus:recollecionstatus,
                        entregastatus:entregastatus, principalstatus:principalstatus, statusadicional:statusadicional, viewextra:viewextra, notificaAgente:notificaAgente,
                        notificaPricing:notificaPricing, notificaLocal: notificaLocal, activo:sol[i].activo,
                    });
                }
                    me.SolicitudT = SolicitusLista;
            }).catch(function(error){
                console.log(error);
            });
        },
        loadActividades(){
            var ctx = document.getElementById('myChart');
            var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Cierre de Venta','Cliente nuevo','Cotizaciones', 'Correos','Llamadas', 'Visitas', 'Cartas de presentación', 'No Viables'],
                    datasets: [{
                        label: 'Actividades en el ultimo mes',
                        data: [10, 0,8, 15, 22, 14, 16,3],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(153, 102, 255, 0.2)', 'rgba(255, 159, 64, 0.2)'
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)'
                        ],
                        borderWidth: 1
                    }],
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: { beginAtZero: true }
                        }]
                    }
                }
            });
        },
        PromedioVenta(){
            this.porsentajecumplido = 85;
            if(this.porsentajecumplido <= 50 ){
                this.ncolor="rgb(255,17,0)";
            }
            if(this.porsentajecumplido > 50 && this.porsentajecumplido <= 75){
                this.ncolor="#2196f3";
            }
            if(this.porsentajecumplido > 75 ){
                this.ncolor="#4caf50";
            }
            return this.porsentajecumplido;
        },
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        async oscar(){
            this.bs = [];
            if(this.BuySellLista.length > 0){
                var i;
                this.dialodload = true;
                this.TotalProfit = 0;

                for(i =0 ; i <= this.BuySellLista.length; i++){
                    this.hbln = '';
                    this.mbln = '';
                    if(i != this.BuySellLista.length){
                        this.nusuario = this.BuySellLista[i].nusuario;
                        this.nagente=  this.BuySellLista[i].agente;
                        this.ntipoOp = this.BuySellLista[i].ntipoOp;
                        this.nbuysell = this.BuySellLista[i].nbuysell;
                        this.nbasis = this.BuySellLista[i].nbasis;
                        this.ncustumer = this.BuySellLista[i].ncustumer;
                        this.nmodalidad = this.BuySellLista[i].nmodalidad;
                        this.fechacreatebs = this.BuySellLista[i].fechacreatebs;
                        if(this.BuySellLista[i].idbasis == 3 || this.BuySellLista[i].idbasis == 4){
                            this.loading = this.BuySellLista[i].receipt;
                            this.discharge = this.BuySellLista[i].delivery;
                        }else{
                            this.loading = this.BuySellLista[i].loading;
                            this.discharge = this.BuySellLista[i].discharge;
                        }
                        this.noscar = this.BuySellLista[i].noscar;
                        if(this.BuySellLista[i].idbasis == 3 || this.BuySellLista[i].idbasis == 4){
                            this.nfechaeta= this.BuySellLista[i].fechaareceipt;
                            this.nfechaetd = this.BuySellLista[i].fechadelivery;
                        }else{
                            this.nfechaeta= this.BuySellLista[i].nfechaeta;
                            this.nfechaetd = this.BuySellLista[i].nfechaetd;
                        }
                        if(this.BuySellLista[i].idbasis == 1 || this.BuySellLista[i].idbasis == 3 || this.BuySellLista[i].idbasis == 2){
                            await this.CargarInformacion(this.BuySellLista[i].idoscar,this.BuySellLista[i].idbs,this.BuySellLista[i].idbasis);
                        }else{
                            this.ncontainer = '-';
                            this.ntamaño =   '-';
                            await this.ListarChargeBS(this.BuySellLista[i].idbs);
                        }
                    }else{
                        this.dialodload = false;
                    }
                }
            }else{
                window.alert('Sin informacion')
            }
        },
        async CargarInformacion(idoscar,idbs,idbasis){
            let me=this; 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var container = [];
            me.ncontainer = '';
            me.ntamaño = '';
            me.tarifasListar = [];
            me.infcontainers = [];
            
            if(idbasis == 2){
                await axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ idoscar,configuracion).then(async function(response){   
                    container=response.data;
                    me.hbln = container[0].hbln;
                    me.mbln = container[0].mbln;
                }).catch(function(error){
                    console.log(error);
                }); 
            }
            if(idbasis == 1){
                await axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ idoscar,configuracion).then(async function(response){                
                    container=response.data;
                    var n = 0;
                    var idsize = 0;
                    var type = '';
                    var size = '';
                    var hbln = '';
                    var hblninf = '';
                    var hblnf = false;
                    var Ncontainer = '';
                    var mbln = '';
                    var mblninf = '';
                    var mblnf = false;
                    for(var i = 0; i < container.length; i++){
                        if(container[i].hbln != ''){
                            if(hblnf == false){
                                hblnf = true;
                                hblninf = container[i].hbln;
                                hbln = container[i].hbln;
                            }
                            container[i].hbln = container[i].hbln.replace(/\s+/g, '');
                            hbln = hbln.replace(/\s+/g, '');
                            if(container[i].hbln != hbln){
                                hblninf = hblninf + ' /-/ '+ container[i].hbln;
                                hbln = container[i].hbln;
                            }
                        }
                        if(container[i].mbln != ''){
                            if(mblnf == false){
                                mblnf = true;
                                mblninf = container[i].mbln;
                                mbln = container[i].mbln;
                            }
                            container[i].mbln = container[i].mbln.replace(/\s+/g, '');
                            mbln = mbln.replace(/\s+/g, '');
                            if(container[i].mbln != mbln){
                                mblninf = mblninf + ' /-/ '+ container[i].mbln;
                                mbln = container[i].mbln;
                            }
                        }
                        me.infcontainers.push({
                            number:container.length,
                            idsize:container[i].idsize,
                            idtype:container[i].idtype,
                            weight:'',
                        });
                        if(n == 0){
                            me.ncontainer = container.length;
                            me.ntamaño =  container[i].size + ' '+  container[i].type;
                            type = container[i].type
                            size = container[i].size;
                            Ncontainer = container[i].size + ' '+  container[i].type;
                        }else{
                            if(Ncontainer != container[i].size + ' '+  container[i].type){
                                me.ncontainer = me.ncontainer + '/-/'+ container.length;
                                me.ntamaño =  me.ntamaño + '/-/' + container[i].size + ' '+  container[i].type;
                                Ncontainer = container[i].size + ' '+  container[i].type;
                            }
                        }
                        n = n + 1;
                    };
                    me.hbln = hblninf;
                    me.mbln = mblninf;
                    await me.ListarChargeBS(idbs);
                }).catch(function(error){
                    console.log(error);
                }); 
             }else{
                await axios.get('api/InlandUnits/ListarContainers/'+ idoscar,configuracion).then(async function(response){
                    container=response.data;
                    var i = 0;
                    var n = 0;
                    var  size = 0;
                    container.map(function(x){
                        n = n + 1;
                            me.infcontainers.push({
                                idcontainer:x.idcontainer,
                                number:container.length,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                weight:me.addCommas(x.grossweight),
                            });
                            size = x.idsize;
                            if(i == 0){
                                me.ncontainer = container.length;
                                me.ntamaño =   x.size + ' '+  x.type;
                            }else{
                                me.ncontainer = me.ncontainer + '/-/'+ container.length;
                                me.ntamaño =  me.ntamaño + '/-/' + x.size + ' '+  x.type;
                            }
                        i = i + 1;
                    }); 
                   await me.ListarChargeBS(idbs);
                }).catch(function(error){
                    console.log(error);
                });
             }
               
        },
        async ListarChargeBS(idbs){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this; 
            var buy=[];
            var sell=[]
            var i;
            var n;
            var tbuy = 0;
            var tsell = 0;
            var total = 0;
            var tbuyiva = 0;
            var tselliva = 0;
            me.totalsell = 0;
            me.totalbuy = 0;
            me.totalselliva = 0;
            me.totalbuyiva = 0;
            me.totalprofitiva = 0;
            me.totalbuybs = 0;
            me.totalsellbs = 0;
            me.tprofitbs = 0;
            var an=0;
            var ans=0;
            await axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(async function(response){                            
                buy=response.data;
                buy.map(async function(x){
                    var totalmxn = 0;
                    if(x.cobrarenpesos == true){
                        totalmxn = me.addCommas(x.totalmxn);
                    } 
                    if(x.payment == 'container'){
                        for(i=0; i < me.infcontainers.length; i++){
                            an = an + 1;
                            if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                tbuyiva = Number(tbuyiva) + Number(x.total);
                                if(x.prepaid != 0){
                                    tbuy = Number(tbuy) + Number(x.prepaid);
                                }
                                if(x.collect != 0){
                                    tbuy = Number(tbuy) + Number(x.collect);
                                }   
                            }
                        }
                    }else{
                        if(x.payment == 'TON/m3'){
                            var costo;
                            var iva;   
                            var total;  
                            
                            if(me.pesovolumen >= me.actualw){
                                if(x.prepaid !=''){
                                    costo = me.pesovolumen * x.prepaid;
                                }else{
                                    costo = me.pesovolumen * x.collect;
                                }
                            }else{
                                if(x.prepaid !=''){
                                    costo = me.actualw * x.prepaid;
                                }else{
                                    costo = me.actualw * x.collect;
                                }
                            }
                            iva = Number(costo) * 0.16;
                            total = Number(costo) + Number(iva);
                            an = an + 1;
                        }else{
                            an = an + 1;
                        }
                        tbuyiva = Number(tbuyiva) + Number(x.total);
                        if(x.prepaid != 0){
                            tbuy = Number(tbuy) + Number(x.prepaid);
                        }
                        if(x.collect != 0){
                            tbuy = Number(tbuy) + Number(x.collect);
                        }
                    }
                });
                me.totalbuyiva = parseFloat(Number(tbuyiva)).toFixed(2);
                me.totalbuy = parseFloat(Number(tbuy)).toFixed(2);
                me.totalbuybs = parseFloat(Number(tbuy)).toFixed(2);
                await axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(async function(response){
                    sell=response.data;
                    var fin = 0;                    
                    await sell.map(async function(x){
                        var totalmxn = 0;
                        if(x.cobrarenpesos == true){
                            totalmxn = me.addCommas(x.totalmxn);
                        }
                        if(x.payment == 'container'){
                                for(i=0; i < me.infcontainers.length; i++){
                                    if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                        ans = ans + 1;
                                        tselliva = Number(tselliva) + Number(x.total);
                                        if(x.prepaid != 0){
                                            tsell = Number(tsell) + Number(x.prepaid);
                                        }
                                        if(x.collect != 0){
                                            tsell = Number(tsell) + Number(x.collect);
                                        }
                                    }
                                }
                        }else{
                            if(x.payment == 'TON/m3'){
                                    var costo;
                                    var iva;   
                                    var total;  
                                    
                                    if(me.pesovolumen >= me.actualw){
                                        if(x.prepaid !=''){
                                            costo = me.pesovolumen * x.prepaid;
                                        }else{
                                            costo = me.pesovolumen * x.collect;
                                        }
                                    }else{
                                        if(x.prepaid !=''){
                                            costo = me.actualw * x.prepaid;
                                        }else{
                                            costo = me.actualw * x.collect;
                                        }
                                    }
                                    iva = Number(costo) * 0.16;
                                    total = Number(costo) + Number(iva);
                                    an = an + 1;
                                    tselliva = Number(tselliva) + Number(x.total);
                                    if(x.prepaid != 0){
                                        tsell = Number(tsell) + Number(x.prepaid);
                                    }
                                    if(x.collect != 0){
                                        tsell = Number(tsell) + Number(x.collect);
                                    }
                            }else{
                                ans = ans + 1;
                                tselliva = Number(tselliva) + Number(x.total);
                                if(x.prepaid != 0){
                                    tsell = Number(tsell) + Number(x.prepaid);
                                }
                                if(x.collect != 0){
                                    tsell = Number(tsell) + Number(x.collect);
                                }
                            }   
                        }
                        fin = fin + 1;
                    });
                                    
                    me.totalselliva = parseFloat(Number(tselliva)).toFixed(2);
                    me.totalsell = parseFloat(Number(tsell)).toFixed(2);
                    me.totalsellbs = parseFloat(Number(tsell)).toFixed(2);
                    me.tprofit = Number(me.totalsellbs) - Number(me.totalbuybs);
                    await me.total(idbs); 
                }).catch(function(error){
                    console.log(error);
                });
                }).catch(function(error){
                    console.log(error);
                });
        },
        async total(idbs){
            this.TotalProfit = this.TotalProfit + this.tprofit;
            
            this.bs.push({
                EJECUTIVO:this.nusuario,
                BS:this.nbuysell,
                OSCAR:this.noscar,
                CLIENTE:this.ncustumer,
                FECHA_GENERADA:this.fechacreatebs,
                POL:this.loading,
                ETD:this.nfechaetd,
                ETA:this.nfechaeta,
                POD:this.discharge,
                MODALITY:this.nmodalidad,
                BASIS:this.nbasis,
                CONTAINERS:this.ncontainer,
                TAMAÑO:this.ntamaño,
                TIPO:this.ntipoOp,
                VENTA:parseFloat(this.totalsellbs).toFixed(2),
                COMPRA:parseFloat(this.totalbuybs).toFixed(2),
                PROFIT:parseFloat(this.tprofit).toFixed(2),
            });
            this.nfooter = false;
            this.limpiar();
        },
        limpiar(){
            this.nusuario = '';
            this.ntipoOp = '';
            this.nbuysell = '';
            this.nbasis = '';
            this.ncustumer = '';
            this.nfechaeta= '';
            this.nfechaetd = '';
            this.nmodalidad = '';
            this.fechacreatebs = '';
            this.loading = '';
            this.discharge = '';
        },
        fechahoy(){
            const date = new Date()
            const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
            const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
            this.fechaHoy = `${month} de ${day} del ${year }`;
            this.fechaHoyN = `${month}-${day}-${year }`;
        },
        async ViewCot(item){
            this.nsubtotalusd = 0;
            this.nivausd = 0;
            this.ntotalusd = 0;
            this.nsubtotalmxn = 0;
            this.nivamxn = 0;
            this.ntotalmxn = 0;
            this.limpiarcotizacion();
            this.limpiarcostos();
            this.productotext = item.producto;
            this.origentext = item.origen;
            this.cuerpo = item.body;
            this.destinotext = item.destino;
            this.serviciotext = item.servicio;
            this.viatext = item.via;
            this.tttext = item.tt;
            this.Movimientotext = item.movimiento;
            this.modalidadtext2 = item.modalidad;
            this.dateval = item.vigencia;
            this.idcustumer = item.idcustumer;
            this.ncotizacion = item.ncotizacion;
            this.ncustumre = item.ncustumer;
            this.folio = item.folio;
            this.idcotizacion = item.idcotizacion;
            this.transbordo = item.transbordo;
            this.lclviewremarks= false;
            await this.listarContacto(item.idcustumer);
            await this.listarconceptos(item.idcotizacion);
            await this.tarifasenviadas(item.idcotizacion);
            await this.listartarifag(item.idcotizacion);
            this.InfoCot = true;     
        },
        limpiarcostos(){
            this.chargeconcepto = '';
            this.chargecostopor = '';
            this.chargecantidad = '';
            this.chargecostounitario = 0;
            this.chargemoneda = '';
            this.chargeiva = '';
            this.editedIndexCosto = -1;
        },
        limpiarcotizacion(){
            this.productotext = '';
            this.origentext = '';
            this.cuerpo = '';
            this.destinotext = '';
            this.serviciotext = '';
            this.viatext = '';
            this.tttext = '';
            this.Movimientotext = '';
            this.modalidadtext2 = '';
            this.dateval = '';
            this.idcustumer = '';
            this.transbordo = '';
            this.idcustumer = 0;
            this.ncotizacion = '';
            this.ncustumre = '';
            this.folio = '';
            this.idcotizacion = '';
            this.contactoscp = '';
            this.contactoscot = '';
            this.cargarremarks()
        },
        cargarremarks(){
            this.RemarksCotizacion = [];
            var remarkfcl = [];
            if(this.contizacioningles == 'INGLES'){
                this.disabledIva = true;
                this.remarkenabled = 6;
                this.bodyCot = 'Our quotation for the services requested is as follows';
                
                remarkfcl.push(
                    {text:'No maneuvers on Airport/Port included, these must be paid by the customs agent.',value:1},
                    {text:'All inlands are quoted in tandem ( 2 containers per truck)',value:2},
                    {text:'No customs maneuvers included.',value:3},
                    {text:'No customs storage included.',value:4},
                    {text:'No inspections included.',value:5},
                    {text:'No custody included.',value:7},
                    {text:'No unloading/loading maneuvers included',value:8},
                    {text:'Free unloading time',value:9},
                    {text:'Rate based on the information provided.',value:10},
                );
            }else{
                this.remarkenabled = 15;
                this.disabledIva = false;
                this.bodyCot = 'Me permito enviarle nuestra cotización';
                remarkfcl.push(
                    {text:'Los costos no incluyen maniobras.',value:1},
                    {text:'horas libres de carga.',value:2},
                    {text:'horas libres de descarga.',value:3},
                    {text:'días de crédito.',value:4},
                    {text:'Sujeto a disponibilidad de espacio y equipo.',value:5},
                    {text:'Incluye Carta Garantía.',value:6},
                    {text:'Los tiempos de tránsito son estimados. ',value:7},
                    {text:'Terrestre dentro de BL en servicio Full.',value:8},
                    {text:'Terrestre dentro de BL en servicio Sencillo.',value:9},
                    {text:'días libres de demoras en origen.',value:10},
                    {text:'días libres de demoras en destino.',value:11},
                    {text:'Costos para carga peligrosa.',value:12},
                    {text:'Costos para carga No peligrosa.',value:13},
                    {text:'Incluye gastos locales en origen.',value:14},
                );
            }
            this.RemarksCotizacion = remarkfcl;
        },
        listarContacto(id){
            var ContactosP = [];
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.contactosprospecto = [];
            me.contactospresente = [];
            axios.get('api/Contactos/ListarContacto/' + id,configuracion).then(function(response){            
            ContactosP=response.data;
            ContactosP.map(function(x){
              me.contactosprospecto.push({text:x.nombre+" <" + x.correo+ ">",value:x.idcontacto,correo:x.correo})
              me.contactospresente.push({text:x.nombre,value:x.idcontacto})
            });
            }).catch(function(error){
                console.log(error);
            });
        },
        async listarconceptos(idcotizacion){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var ArrayObservaciones = [];
            var RemarksCotizacion = '';
            me.remarkstextc = [];
            axios.get('api/ObservacionesCotizacions/Listarcotizacionusuarios/'+ idcotizacion ,configuracion).then(await function(response){                
                ArrayObservaciones=response.data;
                ArrayObservaciones.map(function(x){
                    if(x.idremark > 0 && x.idremark != 100 ){
                        RemarksCotizacion = me.RemarksCotizacion[x.idremark-1].text;
                    }else{
                        RemarksCotizacion = '';
                    }
                    var comentario='';
                    if(x.observacion == ''){
                        comentario = RemarksCotizacion;
                    }
                    else{
                        comentario = x.observacion + " " + RemarksCotizacion;
                    }
                    var activor;
                    if(x.idremark == me.remarkenabled){
                        activor = false
                    }else{
                        activor = true
                    }
                    me.remarkstextc.push({
                        idobs:x.idobs,
                        text: comentario,
                        idremarktext: RemarksCotizacion,
                        observacion: x.observacion,
                        idremark: x.idremark,
                        activo:activor
                    });
                });
                if(me.remarkstextc.length > 0){
                    me.remarksview = true;
                }else{
                    me.remarksview = false;
                }
            }).catch(function(error){
                console.log(error);
            });
        },
        tarifasenviadas(id){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var ArrayCostos = [];
            var subtotal = 0;
            var iva = 0;
            var niva = 0;
            var total = 0;
            me.costos = [];
            me.subtotalusd = 0;
            me.ivausd = 0;
            me.totalusd = 0;
            me.nsubtotalusd = 0;
            me.nivausd = 0;
            me.ntotalusd = 0;
            me.subtotalmxn = 0;
            me.ivamxn = 0;
            me.totalmxn = 0;
            me.nsubtotalmxn = 0;
            me.nivamxn = 0;
            me.ntotalmxn = 0;
            axios.get('api/Tarifas_Cotizaciones/ListarTarifascotizacionusuarios/'+ id ,configuracion).then(function(response){                
                ArrayCostos=response.data;
                ArrayCostos.map(function(x){
                    subtotal = 0;
                    niva = 0;
                    total = 0;
                    if(x.idcostopor == 1 || x.idcostopor == 3 || x.idcostopor == 4){
                        subtotal = x.costounitario * x.cantidad;
                    }
                    if(x.idcostopor == 2 || x.idcostopor == 5){
                        subtotal = Number(x.costounitario);
                    }
                    if(x.iva == 1){
                        niva = subtotal * 0.16;
                        iva = 1;
                    }else{
                        iva = false;
                    }
                    total = (niva + subtotal);
                    if(total == NaN){
                        total = 0;
                    }
                    if(subtotal == NaN){
                        subtotal = 0;
                    }
                    if(x.moneda == 'USD'){
                        me.subtotalusd = me.subtotalusd + subtotal;
                        me.ivausd = me.ivausd + niva;
                        me.totalusd = me.totalusd + total;
                        me.nsubtotalusd = me.addCommas(parseFloat(me.subtotalusd).toFixed(2));
                        me.nivausd = me.addCommas(parseFloat(me.ivausd).toFixed(2))
                        me.ntotalusd = me.addCommas(parseFloat(me.totalusd).toFixed(2))
                        me.activousd = true;
                    }
                    if(x.moneda == 'MXN'){
                        me.subtotalmxn = me.subtotalmxn + subtotal;
                        me.ivamxn = me.ivamxn + niva;
                        me.totalmxn = me.totalmxn + total;
                        me.nsubtotalmxn = me.addCommas(parseFloat(me.subtotalmxn).toFixed(2));
                        me.nivamxn = me.addCommas(parseFloat(me.ivamxn).toFixed(2));
                        me.ntotalmxn = me.addCommas(parseFloat(me.totalmxn).toFixed(2));
                        me.activomxn = true;
                    }
                     me.costos.push({ 
                        idtarifascot:x.idtarifascot,
                        idcostopor:x.idcostopor,
                        concepto: x.concepto,
                        costopor: x.costopor,
                        cantidad: x.cantidad,
                        costounitario: x.costounitario,
                        ncostounitario:me.addCommas(x.costounitario),
                        idmoneda: x.idmoneda,
                        moneda: x.moneda,  
                        iva:x.iva,
                        ivas:x.iva,
                        niva:niva,
                        nniva:me.addCommas(parseFloat(niva).toFixed(2)),
                        subtotal:subtotal,
                        nsubtotal:me.addCommas(parseFloat(subtotal).toFixed(2)),
                        total:total,
                        ntotal:me.addCommas(parseFloat(total).toFixed(2)),
                        activo:true
                    });
                });
            }).catch(function(error){
                console.log(error);
            });
        },
        listartarifag(id){
            let me=this; 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.tarifas = [];
            me.tarifadeliver = [];
            me.tarifapickup = [];
            me.principalview = [];
            var arrayt = [];
            var consulta;
            var ni = 0;
            var primero = false;
            consulta = 'api/TarifasSeleccionadas/ListarContainersUsers/';
                axios.get(consulta + id ,configuracion).then(function(response){                
                    arrayt= response.data;
                    setTimeout(function(){
                        arrayt.map(function(x){
                            ni = ni + 1;
                            me.dateval = x.fechavigencia;
                            var f1 = new Date(x.fechavigencia)
                            var f2 = new Date(me.dateval)
                            if(primero == false){
                                me.dateval = x.fechavigencia;
                                me.vigenciatarifa = x.fechavigencia;
                                primero = true; 
                            }
                            if(f1 < f2){
                                me.dateval = x.fechavigencia;
                                me.vigenciatarifa = x.fechavigencia;
                            }
                            if(x.descripcion == 'Delivery'){
                                me.deliveryview = true;
                                me.tarifadeliver.push({
                                    vigencia:x.vigencia, tipe:x.tipe, tarifaAd:x.tarifaAd, rate:x.rate, observaciones:x.observaciones,
                                    nrate:x.nrate, nidprovider:x.nidprovider, idscotizacion:x.idscotizacion, idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate, idcontainer:x.idcontainer, idagent:x.idagent, idsize:x.idsize,
                                    size:x.size, idtype:x.idtype, type:x.type, general:x.general, freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination, fechavigencia:x.fechavigencia, exclusivo:x.exclusivo,
                                    ex:x.ex, descripcion:x.descripcion, rol:x.rol, quantity:x.quantity, activo:x.activo
                                });
                            }
                            if(x.descripcion == 'Inland Freight' || x.descripcion == 'Ocean Freight' || x.descripcion == 'Air Freight'){
                                me.principalview = true;
                                me.tarifas.push({
                                    vigencia:x.vigencia, tipe:x.tipe, tarifaAd:x.tarifaAd, rate:x.rate, observaciones:x.observaciones,
                                    nrate:x.nrate, nidprovider:x.nidprovider, idscotizacion:x.idscotizacion, idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate, idcontainer:x.idcontainer, idagent:x.idagent, idsize:x.idsize,
                                    size:x.size, idtype:x.idtype, type:x.type, general:x.general, freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination, fechavigencia:x.fechavigencia, exclusivo:x.exclusivo,
                                    ex:x.ex, descripcion:x.descripcion, rol:x.rol, quantity:x.quantity, activo:x.activo
                                });
                            }
                            if(x.descripcion == 'Pickup'){
                                me.recoleccionview = true;
                                me.tarifapickup.push({
                                    vigencia:x.vigencia, tipe:x.tipe, tarifaAd:x.tarifaAd, rate:x.rate, observaciones:x.observaciones,
                                    nrate:x.nrate, nidprovider:x.nidprovider, idscotizacion:x.idscotizacion, idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate, idcontainer:x.idcontainer, idagent:x.idagent, idsize:x.idsize,
                                    size:x.size, idtype:x.idtype, type:x.type, general:x.general, freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination, fechavigencia:x.fechavigencia, exclusivo:x.exclusivo,
                                    ex:x.ex, descripcion:x.descripcion, rol:x.rol, quantity:x.quantity, activo:x.activo
                                });
                            }
                            if(arrayt.length == ni){
                                me.dialodload = false;
                                me.dialog3 = true;
                            }
                        });
                    },0 | Math.random() * 2500);
                }).catch(function(error){
                    console.log(error);
                });
        },
        activarcantidad(){
            if(this.chargecostopor.value == 1){
                this.activarc= false;
            }else{
                this.activarc= true;
            }
        },
        exportExcel: function (val) {
            const xl = XLSX && XLSX.utils ? XLSX : require('xlsx');

            let data = '';
            var name  = '';
            if(val == 1){
                data = xl.utils.json_to_sheet(this.bs)
                name = 'REPORTE DE BS '+ this.fechaHoyN;
            }else{
                data = xl.utils.json_to_sheet(this.CotizacionesDatos)
                name = 'REPORTE DE COTIZACIONES '+ this.fechaHoyN;
            }
            
            const workbook = xl.utils.book_new()
            const filename = name;
            xl.utils.book_append_sheet(workbook, data, 'REPORTE DE BS')
            xl.writeFile(workbook, `${filename}.xlsx`)
        },
        getColor(status) {
            if (status == false) return 'rgb(218,20,6)'
            else if(status == true) return '#4caf50'
        },
    }
}
</script>